import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Radio, Select, Modal, Tooltip, Carousel, Image, Input, Button, Form, DatePicker, Checkbox, notification } from 'antd';
import moment from 'moment';
import Axios from 'axios';
import LS_SERVICE from '../../../utils/localStorage';
import { 
  RISK_FACTORS_LIST,
  RELATIONSHIP_TO_PP_BRIM,
  FETAL_MOVEMENT,
  PRESENTATION,
  Save_Menstrual_History,
  Save_Sexual_History,
  Save_Obstetric_History,
  Save_Obs_Gyane_Data,
  Save_Mother_Parameter_Data,
  Save_Mother_Fetus_Data,
  Get_Obs_Gyane_Data,
  Get_Previous_Obs_Gyane_Data,
  Update_Obs_Gyane_Copy_Status,
  Get_Obs_Gyane_Copy_Status,
  Get_Anc_Previous_Details,
  Save_Pregnant_Audit,
  Get_Pregnant_Audit,
  Save_Lmp_Audit,
  Get_Lmp_Audit,
  Update_Patient_Pregnant_Status,
} from '../../../utils/constant';
import { speechService, speechTextService, pregnantService, lactatingService } from '../../../utils/rxjs-sharing';
import MyHcSpeechRecognition from "../../../pages/speech-to-text/speech-recognition";
import PreviousPregnancyModal from './PreviousPregnancyModal';

const { Option } = Select;

const { TextArea } = Input;



class ObsGynaeComponentSS extends Component {

	constructor(props) {
		super(props);
    this.obsGyaneFormRef = React.createRef();
		this.state = {
			sinceByList: [
        {id: 1, desc: 'Days'},
        {id: 2, desc: 'Weeks'},
        {id: 3, desc: 'Months'},
        {id: 4, desc: 'Years'}
      ],
      speech: {
        identifier: null,
        state: false
      },
      patient_dob : LS_SERVICE.get('call_patient_detail').age,
      pregnant : "0",
      edd_by_lmp : null,
      corrected_edd : null,
      lactating : '0',
      gestational_age_by_lmp_weeks : null,
      gestational_age_by_lmp_days : null,
      gestational_age_by_usg_weeks: null,
      gestational_age_by_usg_days : null,
      pregnancy_risk_factor : [],
      pregnancy_risk_factor_selected: [],
      pregnancy_risk_factor_management_remarks : null,
      any_previous_complications : '0',
      any_previous_complication_details : [],
      obstetric_remarks : null,
      menarch_age : null,
      regularity : null,
      flow : null,
      lmp : null,
      // The LMP value as last persisted (loaded from the server or written by the last save).
      // Used to detect an actual LMP change so an LMP audit is written only when it changes.
      last_saved_lmp : null,
      bleeding_days : null,
      cycle_length : null,
      menstrual_remarks : null,
      sexually_active : '1',
      marital_status : '1',
      spouse_name : null,
      since : null,
      // Default the "Since" unit to Years (id 4) rather than Days.
      since_by : 4,
      married_life : null,
      contraceptives : [],
      confirmed_by : [],
      contraceptive_remarks : null,
      remarks : null,
      sexual_history_data_confidential : '0',
      mother_fetal_print_with_prescription : '0',
      remarks_confidential : '0',
      gravidity : null,
      parity : null,
      abortion : null,
      live_birth : null,
      ectopic : null,
      lscs : null,
      miscarriage : null,
      mtp : null,
      preterm : null,
      term : null,
      still_birth : null,
      obstetric_data_confidential : '0',
      mother_pog : null,
      mother_weight : null,
      mother_blood_pressure : null,
      mother_pulse_rate : null,
      mother_fundal_height : null,
      mother_edema : null,
      mother_pallor : null,
      mother_cervix_exam : null,
      mother_preterm_labour : null,
      no_of_fetus : 0,
      mother_fetal_parameters: [],
      // Id of the latest mother-parameter row fetched/displayed. When present, a save
      // updates that specific row (by id) instead of inserting a new duplicate.
      mother_parameter_id : null,
      menstrual_change_detected : false,
      sexual_change_detected : false,
      obstetric_change_detected : false,
      mother_parameter_change_detected : false,
      mother_fetus_change_detected : false,
      obs_gyane_change_detected : false,
      vitalsData: this.props.vitalsData,
      // True once the latest vital snapshot has been evaluated for mother_weight /
      // mother_blood_pressure / mother_pulse_rate this visit. Vitals fill these fields
      // only when empty (option B), and this flag ensures that happens just once per
      // visit so a later prop refresh never re-applies the same snapshot.
      vitalsApplied: false,
      prevRecordedObsGynaePopupVisible: false,
      pregnantConfirmVisible: false,
      pregnantAuditModalVisible: false,
      pregnantAuditData : [],
      // Edit LMP flow (only when pregnant): popup for a new LMP + reason, with its own audit.
      lmpEditModalVisible: false,
      lmpEditNewDate: null,
      lmpEditReason: '',
      lmpEditSaving: false,
      lmpAuditModalVisible: false,
      lmpAuditData: [],
      obsGynaePrevData : [],
      prevPregnencyCopied : false,
      allowEdit: props.allowEdit,
      // prevAncCardData : []
		};
	}

  // Shared identifiers used by every fetch/save request for this patient visit.
  buildWhereCondition = () => ({
    patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
    reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
    reference_type: 0,
    hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
    enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
    source: 'OP',
  })

  // Form field names grouped by the save module they belong to. Used to validate a
  // module's own fields before saving so invalid data for that module is not persisted.
  moduleFields = {
    menstrual: ['menarch_age', 'regularity', 'flow', 'lmp', 'bleeding_days', 'cycle_length', 'menstrual_remarks'],
    sexual: ['sexually_active', 'marital_status', 'spouse_name', 'since', 'since_by', 'married_life', 'contraceptive_remarks', 'remarks'],
    obstetric: ['gravidity', 'parity', 'abortion', 'live_birth', 'ectopic', 'lscs', 'miscarriage', 'mtp', 'preterm', 'term', 'still_birth'],
    // no_of_fetus is persisted in obs_gyane_data (handleSaveObsGyaneData), so it is
    // validated with the obsGyane module rather than motherParameter.
    obsGyane: ['gestational_age_by_lmp_weeks', 'gestational_age_by_lmp_days', 'gestational_age_by_usg_weeks', 'gestational_age_by_usg_days', 'pregnancy_risk_factor', 'pregnancy_risk_factor_management_remarks', 'obstetric_remarks', 'no_of_fetus'],
    motherParameter: ['mother_pog', 'mother_weight', 'mother_blood_pressure', 'mother_pulse_rate', 'mother_fundal_height', 'mother_edema', 'mother_pallor', 'mother_cervix_exam', 'mother_preterm_labour', 'mother_remarks'],
    // Fetal parameter inputs have no registered validators; the only validation that
    // affects the fetus records is No. of Fetus, so gate the fetus save on it.
    motherFetus: ['no_of_fetus'],
  }

  // Clears any inline validation errors that validateFields may have painted, without
  // touching field values. Used after the automatic load-time copy so required-field
  // errors (e.g. "Please fill No. Of Fetus.") don't show before the user interacts.
  clearObsGyaneValidationErrors = () => {
    const form = this.obsGyaneFormRef.current;
    if (!form) return;
    const allFields = Object.values(this.moduleFields).reduce((acc, arr) => acc.concat(arr), []);
    // Deduplicate (no_of_fetus appears in more than one module).
    const uniqueFields = [...new Set(allFields)];
    form.setFields(uniqueFields.map((name) => ({ name, errors: [] })));
  }

  // Validates only the given module's fields. Resolves to true when all are valid,
  // false when any fail validation. Never throws.
  isModuleValid = async (moduleName) => {
    const fields = this.moduleFields[moduleName];
    if (!fields || !this.obsGyaneFormRef.current) return true;
    try {
      await this.obsGyaneFormRef.current.validateFields(fields);
      return true;
    } catch (err) {
      // validateFields rejects with { errorFields } when there are errors, but may
      // also resolve-reject with the full values object; treat only real errors as invalid.
      if (err && Array.isArray(err.errorFields) && err.errorFields.length > 0) {
        return false;
      }
      return true;
    }
  }

  // Synchronous menstrual-history validation against component state. Mirrors the antd
  // Form.Item rules (menarch_age 7..patient age, bleeding_days 1..99, cycle_length 10..99) but
  // does NOT touch the antd form, so it is safe to call during unmount/teardown when
  // validateFields() can hang. Empty values are allowed (same as the form rules). Returns true
  // when all present values are within range.
  isMenstrualDataValidSync = () => {
    const inRange = (value, min, max) => {
      if (value === '' || value === null || value === undefined) return true; // empty = valid
      const num = +value;
      if (isNaN(num)) return false;
      return num >= min && num <= max;
    };
    // Patient age is the upper bound for menarch age (same as the form rule's `max`).
    const maxMenarch = (this.state.patient_dob !== '' && this.state.patient_dob !== null && this.state.patient_dob !== undefined)
      ? +this.state.patient_dob
      : 99;
    if (!inRange(this.state.menarch_age, 7, maxMenarch)) return false;
    if (!inRange(this.state.bleeding_days, 1, 99)) return false;
    if (!inRange(this.state.cycle_length, 10, 99)) return false;
    return true;
  }

  // Reads obstetric field values from component state as integers (NaN when blank/absent),
  // for synchronous validation that does not depend on the antd form ref (safe during unmount).
  getObstetricValuesFromState = () => {
    const num = (v) => (v === undefined || v === null || v === '') ? NaN : parseInt(v);
    return {
      gravidity: num(this.state.gravidity),
      parity: num(this.state.parity),
      abortion: num(this.state.abortion),
      live_birth: num(this.state.live_birth),
      ectopic: num(this.state.ectopic),
      lscs: num(this.state.lscs),
      miscarriage: num(this.state.miscarriage),
      mtp: num(this.state.mtp),
      preterm: num(this.state.preterm),
      term: num(this.state.term),
      still_birth: num(this.state.still_birth),
      isPregnant: this.state.pregnant == '1',
    };
  }

  // Synchronous obstetric-history validation against component state. Mirrors the antd
  // Form.Item validators (1-2 digit numbers + the interdependent relationships) without
  // touching the antd form, so it is safe during unmount/teardown. Empty fields are allowed.
  isObstetricDataValidSync = () => {
    const raw = {
      gravidity: this.state.gravidity, parity: this.state.parity, abortion: this.state.abortion,
      live_birth: this.state.live_birth, ectopic: this.state.ectopic, lscs: this.state.lscs,
      miscarriage: this.state.miscarriage, mtp: this.state.mtp, preterm: this.state.preterm,
      term: this.state.term, still_birth: this.state.still_birth,
    };
    // Each present value must be a 1-2 digit number.
    for (const key of Object.keys(raw)) {
      const v = raw[key];
      if (v === '' || v === null || v === undefined) continue; // empty = valid
      if (!/^\d{1,2}$/.test(String(v))) return false;
    }
    const { gravidity, parity, abortion, live_birth, ectopic, lscs, miscarriage, mtp, preterm, term, still_birth, isPregnant } = this.getObstetricValuesFromState();
    // Gravida >= Parity + Abortion (+ current pregnancy)
    if (!isNaN(gravidity)) {
      let minGravida = 0;
      if (!isNaN(parity)) minGravida += parity;
      if (!isNaN(abortion)) minGravida += abortion;
      if (isPregnant) minGravida += 1;
      if (gravidity < minGravida) return false;
    }
    // Parity = Term + Pre-term + Still Birth
    if (!isNaN(parity) && !isNaN(term) && !isNaN(preterm) && !isNaN(still_birth)) {
      if (parity !== (term + preterm + still_birth)) return false;
    }
    // Abortion = Miscarriage + MTP + Ectopic
    if (!isNaN(abortion) && !isNaN(miscarriage) && !isNaN(mtp) && !isNaN(ectopic)) {
      if (abortion !== (miscarriage + mtp + ectopic)) return false;
    }
    // Component caps vs their parent totals.
    if (!isNaN(live_birth) && !isNaN(parity) && live_birth > parity) return false;
    if (!isNaN(ectopic) && !isNaN(abortion) && ectopic > abortion) return false;
    if (!isNaN(miscarriage) && !isNaN(abortion) && miscarriage > abortion) return false;
    if (!isNaN(mtp) && !isNaN(abortion) && mtp > abortion) return false;
    if (!isNaN(lscs) && !isNaN(parity) && lscs > parity) return false;
    if (!isNaN(preterm) && !isNaN(parity) && preterm > parity) return false;
    if (!isNaN(term) && !isNaN(parity) && term > parity) return false;
    if (!isNaN(still_birth) && !isNaN(parity) && still_birth > parity) return false;
    return true;
  }

  // Synchronous No. of Fetus validation (1-9) used by the obs-gyane and fetus saves on unmount.
  // Only enforced when the patient is pregnant (the field is required/visible only then).
  isNoOfFetusValidSync = () => {
    if (this.state.pregnant != '1') return true;
    const v = this.state.no_of_fetus;
    if (v === '' || v === null || v === undefined) return false; // required when pregnant
    return /^[1-9]$/.test(String(v).trim());
  }

  // Fetal Heart Rate is mandatory for every fetus row before fetus data can be saved.
  // Returns the 1-based index of the first fetus missing FHR, or 0 when all are valid.
  // Only applies when the patient is pregnant and fetus rows exist.
  firstInvalidFetusHeartRate = () => {
    if (this.state.pregnant != "1") return 0;
    const rows = this.state.mother_fetal_parameters || [];
    for (let i = 0; i < rows.length; i++) {
      const fhr = rows[i]?.fetal_heart_rate;
      if (fhr === undefined || fhr === null || String(fhr).trim() === '') {
        return i + 1;
      }
    }
    return 0;
  }

  // True when every fetus row has a Fetal Heart Rate (or the section doesn't apply).
  isFetusHeartRateValid = () => this.firstInvalidFetusHeartRate() === 0;

  // Reads the current obstetric-history field values from the form as numbers.
  // Returns NaN for blank/absent fields so validators can skip incomplete input.
  getObstetricValues = () => {
    const form = this.obsGyaneFormRef.current;
    const num = (name) => {
      const v = form?.getFieldValue(name);
      return (v === undefined || v === null || v === '') ? NaN : parseInt(v);
    };
    return {
      gravidity: num('gravidity'),
      parity: num('parity'),
      abortion: num('abortion'),
      live_birth: num('live_birth'),
      ectopic: num('ectopic'),
      lscs: num('lscs'),
      miscarriage: num('miscarriage'),
      mtp: num('mtp'),
      preterm: num('preterm'),
      term: num('term'),
      still_birth: num('still_birth'),
      isPregnant: this.state.pregnant == '1',
    };
  }

  // Returns true when the given sub-item id (under section id 16) is marked selected
  // for the current consult type's screen configuration.
  isSubItemSelected = (subItemId) => {
    const { ss_configuration, consult_type } = this.state;
    if (!ss_configuration) return false;
    return ss_configuration.some(o => (
      o?.id === 16 && o?.sub_items?.some(p => (
        p?.id === subItemId && p?.configuration?.[consult_type + '_screen']?.selected == 'Y'
      ))
    ));
  }

  // Maps a menstrual_data payload into both component state and the antd form.
  // Shared by getPatientObsGyaneData (current visit) and copyPrevRecordedObsGynae (previous visit).
  // `obs_gyane_data` (optional) is used as a fallback source for LMP: when the menstrual
  // history has no LMP, derive it from the obs/gynae EDD By LMP (LMP = EDD - 40 weeks) so the
  // LMP field is still populated for pregnant patients whose LMP lives on the obs/gynae record.
  // Gestational Age from an LMP (whole calendar days, DATE-ONLY so a time/timezone component
  // can't shift the day and inflate GA). Returns { weeks, days } — identical math to the ANC
  // card's getGAToday, so GA "By LMP" matches across screens (e.g. 02 Oct -> 05 Oct = 0w 3d).
  computeGaFromLmp = (lmp) => {
    if (!lmp || !moment(lmp).isValid()) {
      return { weeks: null, days: null };
    }
    const totalDays = moment(moment().format('YYYY-MM-DD')).diff(moment(moment(lmp).format('YYYY-MM-DD')), 'days');
    if (isNaN(totalDays) || totalDays < 0) {
      return { weeks: 0, days: 0 };
    }
    return { weeks: Math.floor(totalDays / 7), days: totalDays % 7 };
  }

  applyMenstrualData = async (menstural_data, obs_gyane_data = null) => {
    // Even when there is no menstrual history, we may still be able to show an LMP derived
    // from the obs/gynae data, so don't bail out early unless both sources are absent.
    if (!menstural_data && !obs_gyane_data) return;
    const values = {
      menarch_age : menstural_data?.menarch_age || null,
      regularity : menstural_data?.regularity || null,
      flow : menstural_data?.flow || null,
      bleeding_days : menstural_data?.bleeding_days,
      cycle_length : menstural_data?.cycle_length,
      menstrual_remarks : menstural_data?.menstrual_remarks || null,
    };
    // Prefer the LMP saved in menstrual history; otherwise fall back to the obs/gynae LMP
    // derived from EDD By LMP (EDD = LMP + 40 weeks, so LMP = EDD - 40 weeks).
    let lmp = (menstural_data?.lmp && menstural_data.lmp != null) ? moment(menstural_data.lmp) : null;
    if (!lmp && obs_gyane_data?.edd_by_lmp && obs_gyane_data.edd_by_lmp != null) {
      const derived = moment(obs_gyane_data.edd_by_lmp).subtract(40, 'weeks');
      if (derived.isValid()) {
        lmp = derived;
      }
    }
    const lmpFormatted = lmp ? lmp.format('YYYY-MM-DD') : null;
    // Compute GA (By LMP) from the loaded LMP so the Gestational Age weeks/days fields are
    // populated on open — previously they stayed blank because GA was only recomputed in the
    // LMP-change handlers, not in this shared load path.
    const ga = this.computeGaFromLmp(lmpFormatted);
    // Record the loaded LMP as the baseline so a later save only audits a genuine change.
    await this.setState({
      ...values,
      lmp: lmpFormatted,
      last_saved_lmp: lmpFormatted,
      gestational_age_by_lmp_weeks: ga.weeks,
      gestational_age_by_lmp_days: ga.days,
    });
    await this.obsGyaneFormRef.current.setFieldsValue({
      ...values,
      lmp,
      gestational_age_by_lmp_weeks: ga.weeks,
      gestational_age_by_lmp_days: ga.days,
    });
  }

  applySexualData = async (sexual_data) => {
    if (!sexual_data) return;
    const values = {
      sexually_active : sexual_data?.sexually_active || null,
      marital_status : sexual_data?.marital_status || '1',
      spouse_name : sexual_data?.spouse_name || null,
      since : sexual_data?.since,
      // Default the "Since" unit to Years (id 4) when none is saved.
      since_by : sexual_data?.since_by || 4,
      married_life : sexual_data?.married_life || null,
      contraceptives : (sexual_data?.contraceptives && sexual_data?.contraceptives != "" && sexual_data?.contraceptives != null) ? sexual_data.contraceptives.split(','): [],
      contraceptive_remarks : sexual_data?.contraceptive_remarks || null,
      remarks : sexual_data?.remarks || null,
      sexual_history_data_confidential : sexual_data?.sexual_history_data_confidential || '0',
      remarks_confidential : sexual_data?.remarks_confidential || '0',
    };
    await this.setState({ ...values });
    await this.obsGyaneFormRef.current.setFieldsValue({ ...values });
  }

  applyObstetricData = async (obstetric_data) => {
    if (!obstetric_data) return;
    const values = {
      gravidity : obstetric_data?.gravidity,
      parity : obstetric_data?.parity,
      abortion : obstetric_data?.abortion,
      live_birth : obstetric_data?.live_birth,
      ectopic : obstetric_data?.ectopic,
      lscs : obstetric_data?.lscs,
      miscarriage : obstetric_data?.miscarriage,
      mtp : obstetric_data?.mtp,
      preterm : obstetric_data?.preterm,
      term : obstetric_data?.term,
      still_birth : obstetric_data?.still_birth,
      obstetric_data_confidential : obstetric_data?.confidential || '0',
    };
    await this.setState({ ...values });
    await this.obsGyaneFormRef.current.setFieldsValue({ ...values });
  }

  // A reference id can accumulate multiple mother-parameter records (repeated saves).
  // Normalize to the single latest record: if given an array, return the one with the
  // highest id (or the last element when ids are absent); otherwise return the object as-is.
  pickLatestMotherParameter = (data) => {
    if (Array.isArray(data)) {
      if (data.length === 0) return null;
      const hasIds = data.every(d => d && d.id != null);
      if (hasIds) {
        return data.reduce((latest, cur) => (cur.id > latest.id ? cur : latest), data[0]);
      }
      return data[data.length - 1];
    }
    return data || null;
  }

  // Fetus rows are a flat array that may contain several save batches for the same
  // reference id. We always show the LATEST record per fetus_no: group rows by their
  // fetus number and keep the one with the highest id, ordered by fetus_no ascending.
  //
  // Legacy fallback: if rows have no fetus_no, use the old "last `count` rows by id"
  // behaviour (each batch had `no_of_fetus` rows written consecutively).
  pickLatestFetusBatch = (rows, count) => {
    if (!Array.isArray(rows) || rows.length === 0) return [];

    // Prefer grouping by fetus_no when the rows carry it.
    const hasFetusNo = rows.some(r => r && r.fetus_no != null && r.fetus_no !== '');
    if (hasFetusNo) {
      const latestByFetus = {};
      rows.forEach(r => {
        if (!r) return;
        // Rows without a fetus_no can't be grouped; skip them in this mode.
        if (r.fetus_no == null || r.fetus_no === '') return;
        const key = parseInt(r.fetus_no);
        const existing = latestByFetus[key];
        // Keep the row with the highest id (latest save) for each fetus number.
        if (!existing || ((r.id != null ? r.id : 0) > (existing.id != null ? existing.id : 0))) {
          latestByFetus[key] = r;
        }
      });
      return Object.keys(latestByFetus)
        .map(k => parseInt(k))
        .sort((a, b) => a - b)
        .map(k => latestByFetus[k]);
    }

    // Legacy fallback (no fetus_no on any row): last `count` rows by id.
    const ordered = rows.every(r => r && r.id != null)
      ? [...rows].sort((a, b) => a.id - b.id)
      : [...rows];
    const n = parseInt(count);
    if (!isNaN(n) && n > 0 && n <= ordered.length) {
      return ordered.slice(ordered.length - n);
    }
    return ordered;
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.vitalsData !== prevState.vitalsData) {
        return { vitalsData: nextProps.vitalsData }
    }
    return null;
  }

  // The parent fetches vitals asynchronously, so vitalsData may arrive as a prop after
  // this component mounted (when the initial updateVitals() found no vitals yet). Fill
  // any empty weight/BP/pulse once it becomes available; updateVitals is guarded by
  // vitalsApplied so it still runs only once per visit and never overwrites existing values.
  async componentDidUpdate(prevProps) {
    if (this.props.vitalsData !== prevProps.vitalsData && !this.state.vitalsApplied) {
      await this.updateVitals();
    }
  }

	async componentDidMount() {
    // Vitals are applied AFTER the saved obs/gynae data loads (see below). With option B
    // the vital only fills weight/BP/pulse when they are still empty, so "empty" must be
    // evaluated against the loaded saved values (and any previous-visit copy).
    await this.optionRiskFactorsList();
    const ss_configuration = LS_SERVICE.get('ss_configuration');
    const patient_full_data = LS_SERVICE.get('call_patient_detail');
    await this.setState({
        ss_configuration: ss_configuration,
        consult_type: patient_full_data?.consult_type == 1 ? 'vc' : 'opd'
    })
    this.subscription = speechTextService.status().subscribe(data => {
      if (this.state.speech.state) {
        if (this.state.speech.identifier === 'menstrual_remarks') {
          this.setState({ menstrual_remarks: data.text, menstrual_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ menstrual_remarks: data.text });
        }
        if (this.state.speech.identifier === 'married_life') {
          this.setState({ married_life: data.text, sexual_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ married_life: data.text });
        }
        if (this.state.speech.identifier === 'contraceptive_remarks') {
          this.setState({ contraceptive_remarks: data.text, sexual_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ contraceptive_remarks: data.text });
        }
        if (this.state.speech.identifier === 'remarks') {
          this.setState({ remarks: data.text, sexual_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ remarks: data.text });
        }
        if (this.state.speech.identifier === 'pregnancy_risk_factor_management_remarks') {
          this.setState({ pregnancy_risk_factor_management_remarks: data.text, obs_gyane_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ pregnancy_risk_factor_management_remarks: data.text });
        }
        if (this.state.speech.identifier === 'obstetric_remarks') {
          this.setState({ obstetric_remarks: data.text, obs_gyane_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ obstetric_remarks: data.text });
        }
        if (this.state.speech.identifier === 'mother_remarks') {
          this.setState({ mother_remarks: data.text, mother_parameter_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ mother_remarks: data.text });
        }
        document.querySelector("#" + this.state.speech.identifier).style.height = document.querySelector("#" + this.state.speech.identifier).scrollHeight + "px";
      }
    });
    // These three fetches are independent of each other and can run concurrently.
    // prevRecordedObsGynae depends on copy-status and previous data, so it runs after.
    await Promise.all([
      this.getPatientObsGyaneData(),
      this.getPatientObsGyaneCopyStatus(),
      this.getPatientPreviousObsGyaneData(),
    ]);
    await this.prevRecordedObsGynae();
    // Now that saved data (and any previous-visit copy) has loaded, fill any empty
    // weight/BP/pulse from the latest vital without overwriting existing values.
    await this.updateVitals();
    // AncPreviousDetails and pregnant audit are independent; no need to block on them.
    // this.getPatientAncPreviousDetails();
    this.getPregnantAudit();
    this.getLmpAudit();
	}

  prevRecordedObsGynae = async (e, type) => {
    if(LS_SERVICE.get('call_patient_detail')?.gender == 'Female' && LS_SERVICE.get('PATIENT_PREGNANT_STATUS') == "1" && this.state.prevPregnencyCopied == false)
    {
      this.copyPrevRecordedObsGynae('Y')
      /************************ Not required popup now data auto copied *************************/
      // this.setState({
      //   prevRecordedObsGynaePopupVisible: true
      // })
    }
    else
    {
      this.copyPrevRecordedObsGynae('N')
    }
  }

  closePopup = async (e, type) => {
    if(type == 'prevRecordedObsGynae'){
      await this.setState({
        prevRecordedObsGynaePopupVisible : false
      })
    }
    if(type == 'obsHistoryList'){
      await this.setState({
        previousPregnancyDetailsModal : false
      })
    }
  }

  // getPatientAncPreviousDetails = async () => {
  //   let Params = {
  //     patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
  //     current_reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
  //     // reference_type: 0,
  //     // hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
  //     enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
  //     // source: 'OP',  // Patient Specific Data
  //   }
  //   await Axios.post(Get_Anc_Previous_Details,Params).then(async res => {
  //   if(res.data.status == true)
  //   {
  //     await this.setState({
  //       prevAncCardData : res.data.data
  //     })
  //   }
  //   else
  //   {
  //     await this.setState({
  //       prevAncCardData : []
  //     })
  //   }
  //   })
  //   .catch(error => {
  //     notification.error({
  //       message: 'Something went wrong! Unable to fetch the data',
  //       placement: 'topRight'
  //     })
  //   })
  // }

  copyPrevRecordedObsGynae = async (value) => {
    var obsGynaePrevData = this.state.obsGynaePrevData;
    if(value == 'Y'){
      /*********************** Menstural Data Fetch ****************************/
      let menstural_data = obsGynaePrevData.menstural_data;
      // Apply menstrual history, passing the previous obs/gynae data as a fallback LMP source
      // (derived from EDD By LMP) so LMP shows even when menstrual history has no LMP.
      await this.applyMenstrualData(menstural_data, obsGynaePrevData);
      if(menstural_data)
      {
        if(menstural_data?.lmp && menstural_data.lmp != null)
        {
          // Shared GA-from-LMP helper (DATE-ONLY, matches the ANC card's getGAToday).
          const ga = this.computeGaFromLmp(this.state.lmp);
          const gestational_age_by_lmp_weeks = ga.weeks;
          const gestational_age_by_lmp_days = ga.days;
          await this.setState({
            gestational_age_by_lmp_weeks : gestational_age_by_lmp_weeks,
            gestational_age_by_lmp_days : gestational_age_by_lmp_days,
            mother_pog : gestational_age_by_lmp_weeks,
          });
          await this.obsGyaneFormRef.current.setFieldsValue({
            mother_pog: gestational_age_by_lmp_weeks,
            gestational_age_by_lmp_weeks: gestational_age_by_lmp_weeks,
            gestational_age_by_lmp_days: gestational_age_by_lmp_days,
          });
        }
      }

      /*********************** Sexual Data Fetch ****************************/
      await this.applySexualData(obsGynaePrevData.sexual_data);

      /*********************** Obstetric Data Fetch ****************************/
      await this.applyObstetricData(obsGynaePrevData.obstetric_data);

      /*********************** Obs Gyane Data Fetch ****************************/
      let obs_gyane_data = obsGynaePrevData;
      if(obs_gyane_data)
      {
        if(obs_gyane_data?.pregnancy_risk_factor != null && obs_gyane_data?.pregnancy_risk_factor !== "")
        {
          let pregnancy_risk_factor_saved = obs_gyane_data?.pregnancy_risk_factor.split(',');
          let pregnancy_risk_factor_selected = [];
          for (var i = 0; i < pregnancy_risk_factor_saved.length; i++) {
              pregnancy_risk_factor_selected.push(parseInt(pregnancy_risk_factor_saved[i]));
          }
          await this.setState({
              pregnancy_risk_factor : pregnancy_risk_factor_selected,
              pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
          });
          await this.obsGyaneFormRef.current.setFieldsValue({
              pregnancy_risk_factor : pregnancy_risk_factor_selected,
              pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
          });
        }
        await this.setState({
          pregnant : obs_gyane_data?.pregnant || '0',
          lactating : obs_gyane_data?.lactating || '0',
          pregnancy_risk_factor_management_remarks : obs_gyane_data?.pregnancy_risk_factor_management_remarks || null,
          any_previous_complications : obs_gyane_data?.any_previous_complications || '0',
          any_previous_complication_details : (obs_gyane_data?.any_previous_complication_details && obs_gyane_data?.any_previous_complication_details != "" && obs_gyane_data?.any_previous_complication_details != null) ? obs_gyane_data.any_previous_complication_details.split(','): [],
          obstetric_remarks : obs_gyane_data?.obstetric_remarks || null,
        });

        await this.obsGyaneFormRef.current.setFieldsValue({
          pregnant : obs_gyane_data?.pregnant || '0',
          lactating : obs_gyane_data?.lactating || '0',
          pregnancy_risk_factor_management_remarks : obs_gyane_data?.pregnancy_risk_factor_management_remarks || null,
          any_previous_complications : obs_gyane_data?.any_previous_complications || '0',
          any_previous_complication_details : (obs_gyane_data?.any_previous_complication_details && obs_gyane_data?.any_previous_complication_details != "" && obs_gyane_data?.any_previous_complication_details != null) ? obs_gyane_data.any_previous_complication_details.split(','): [],
          obstetric_remarks : obs_gyane_data?.obstetric_remarks || null,
        });
      }

      // A reference id may have multiple mother-parameter rows; use the latest.
      let mother_parameter_data = this.pickLatestMotherParameter(obsGynaePrevData.mother_parameter_data);
      // Only the latest fetus batch (last `no_of_fetus` rows) represents the current set.
      const prev_latest_fetus_batch = this.pickLatestFetusBatch(obsGynaePrevData?.mother_fetus_data, obs_gyane_data?.no_of_fetus);
      // No. of Fetus strictly reflects the actual count of fetus rows copied (latest batch).
      // When there is no fetal data to copy, leave it empty (null) rather than defaulting to a
      // stale stored value, so the field always matches the fetal data present.
      const prev_fetus_count = prev_latest_fetus_batch.length;
      const copied_no_of_fetus = (prev_fetus_count > 0) ? prev_fetus_count : null;
      // Gestational age by USG is derived from the Corrected EDD (recomputed for "today"),
      // not copied verbatim, so it stays correct after a copy from a previous visit.
      const copied_corrected_edd = (obs_gyane_data?.corrected_edd && obs_gyane_data.corrected_edd != null) ? moment(obs_gyane_data.corrected_edd).format('YYYY-MM-DD') : null;
      const copied_usg_ga = this.getGestationalAgeFromEdd(copied_corrected_edd);
      await this.setState({
        // Copying from a previous visit creates new rows for the current reference id,
        // so there is no existing mother-parameter row to update by id.
        mother_parameter_id : null,
        no_of_fetus : copied_no_of_fetus,
        corrected_edd : copied_corrected_edd,
        edd_by_lmp : (obs_gyane_data?.edd_by_lmp && obs_gyane_data.edd_by_lmp != null) ? moment(obs_gyane_data.edd_by_lmp).format('YYYY-MM-DD'): null,
        confirmed_by : (obs_gyane_data?.confirmed_by && obs_gyane_data?.confirmed_by != "" && obs_gyane_data?.confirmed_by != null) ? obs_gyane_data.confirmed_by.split(','): [],
        // gestational_age_by_lmp_weeks : obs_gyane_data?.gestational_age_by_lmp_weeks,
        // gestational_age_by_lmp_days : obs_gyane_data?.gestational_age_by_lmp_days,
        gestational_age_by_usg_days : copied_usg_ga.days,
        gestational_age_by_usg_weeks : copied_usg_ga.weeks,
        // mother_pog : mother_parameter_data?.pog || null,
        // Weight, BP and pulse are NOT copied from the previous visit; they come from
        // this visit's latest vital (applied by updateVitals). Leave them empty here.
        mother_weight : null,
        mother_blood_pressure : null,
        mother_pulse_rate : null,
        mother_fundal_height : mother_parameter_data?.fundal_height || null,
        mother_edema : mother_parameter_data?.edema || null,
        mother_pallor : mother_parameter_data?.pallor || null,
        mother_cervix_exam : mother_parameter_data?.cervix_exam || null,
        mother_preterm_labour : mother_parameter_data?.preterm_labour || null,
        mother_remarks : mother_parameter_data?.mother_remarks || null,
        mother_fetal_print_with_prescription : obs_gyane_data?.mother_fetal_print_with_prescription || '0',
      });

      await this.obsGyaneFormRef.current.setFieldsValue({
        no_of_fetus : copied_no_of_fetus,
        corrected_edd : copied_corrected_edd ? moment(copied_corrected_edd) : null,
        edd_by_lmp : (obs_gyane_data?.edd_by_lmp && obs_gyane_data.edd_by_lmp != null) ? moment(obs_gyane_data.edd_by_lmp): null,
        confirmed_by : (obs_gyane_data?.confirmed_by && obs_gyane_data?.confirmed_by != "" && obs_gyane_data?.confirmed_by != null) ? obs_gyane_data.confirmed_by.split(','): [],
        // gestational_age_by_lmp_weeks : obs_gyane_data?.gestational_age_by_lmp_weeks,
        // gestational_age_by_lmp_days : obs_gyane_data?.gestational_age_by_lmp_days,
        gestational_age_by_usg_days : copied_usg_ga.days,
        gestational_age_by_usg_weeks : copied_usg_ga.weeks,
        // mother_pog : mother_parameter_data?.pog || null,
        // Weight, BP and pulse are NOT copied from the previous visit; they come from
        // this visit's latest vital (applied by updateVitals). Leave them empty here.
        mother_weight : null,
        mother_blood_pressure : null,
        mother_pulse_rate : null,
        mother_fundal_height : mother_parameter_data?.fundal_height || null,
        mother_edema : mother_parameter_data?.edema || null,
        mother_pallor : mother_parameter_data?.pallor || null,
        mother_cervix_exam : mother_parameter_data?.cervix_exam || null,
        mother_preterm_labour : mother_parameter_data?.preterm_labour || null,
        mother_remarks : mother_parameter_data?.mother_remarks || null,
        mother_fetal_print_with_prescription : obs_gyane_data?.mother_fetal_print_with_prescription || '0',
      });

      /******************** Mother Fetus Data Fetch ******************************/
      // Use only the latest fetus batch computed above (not every accumulated batch).
      let mother_fetal_parameters = [];
      if(Array.isArray(prev_latest_fetus_batch) && prev_latest_fetus_batch.length > 0)
      {
        prev_latest_fetus_batch.forEach((ele, idx) => {
          // No id (copy creates new rows); keep fetus_no so the fetus number is preserved.
          let obj = { fetus_no: (ele.fetus_no != null && ele.fetus_no !== '') ? ele.fetus_no : (idx + 1), fetal_movement: ele.fetal_movement, fetal_heart_rate: ele.fetal_heart_rate, presentation: ele.presentation, relationship_of_pp_to_brim: ele.relationship_of_pp_to_brim, head_cc: ele.head_cc, abdominal_cc: ele.abdominal_cc, femur_length: ele.femur_length }
          mother_fetal_parameters.push(obj);
        });

        await this.setState({
          mother_fetal_parameters : mother_fetal_parameters,
        });

        await this.obsGyaneFormRef.current.setFieldsValue({
          mother_fetal_parameters : mother_fetal_parameters,
        });
      }

      // Save each section after copy. Awaited so validation gating runs against the
      // freshly-copied values and any errors surface consistently.
      await this.handleSaveObsGyaneData();
      await this.handleSaveMenstrualHistory();
      await this.handleSaveSexualHistory();
      await this.handleSaveObstetricHistory();
      await this.handleSaveMotherParameterData();
      await this.handleSaveMotherFetusData();

      // The save chain above calls validateFields (via isModuleValid), which paints
      // validation errors inline. On this automatic load-time copy we don't want those
      // errors shown before the user interacts, so clear them for the copied fields.
      this.clearObsGyaneValidationErrors();

      // Copying a previous pregnancy marks this patient pregnant; persist the flag and
      // notify the left sidebar / SOAP header (Pregnancy Active / Close Pregnancy).
      if (this.state.pregnant == "1") {
        LS_SERVICE.set('PATIENT_PREGNANT_STATUS', "1");
        pregnantService.init({ is_pregnant: "1" });
        // Set Patient.is_pregnant once via the dedicated endpoint (also opens the ANC card),
        // since the regular obs/gynae save no longer updates the patient-level flag.
        await this.updatePatientPregnantStatus("1");
      }
    }
    var params = {
      reference_id: LS_SERVICE.get('call_patient_qms_token_id'),
      reference_type: LS_SERVICE.get('reference_type'),
      status: value
    }
    await Axios.post(Update_Obs_Gyane_Copy_Status, params);
    // this.closePopup(e, 'prevRecordedObsGynae')
  }


  // True when a mother-parameter value is effectively empty (null/undefined/blank),
  // meaning nothing was saved for this visit and no manual entry exists yet.
  isMotherParamEmpty = (value) => (value === undefined || value === null || String(value).trim() === '');

  // Fills the mother parameters from the latest vital snapshot. Option B behaviour:
  // the vital only populates a field when it is still empty, so a previously saved value
  // or a doctor's manual entry is never overwritten. Called AFTER the saved obs/gynae
  // data loads (see componentDidMount) so "empty" reflects the loaded state.
  //
  // Guarded by `vitalsApplied` so the same vital snapshot is applied only once per visit
  // (it won't re-fire on every prop refresh). When any field is filled it marks
  // mother_parameter_change_detected so the newly filled value is persisted on save/unmount.
  async updateVitals(){
    // Only apply once per visit.
    if (this.state.vitalsApplied) {
      return;
    }

    const vitals = this.props?.vitalsData;
    if (!vitals) {
      return;
    }

    const updatedState = {};
    const updatedFields = {};
    let anyApplied = false;

    // Blood pressure: systolic (V006) / diastolic (V005). Fill only when empty.
    if (this.isMotherParamEmpty(this.state.mother_blood_pressure) && ((vitals.V005 && vitals.V005 > 0) || (vitals.V006 && vitals.V006 > 0))) {
      const bp = vitals.V006 + '/' + vitals.V005;
      updatedState.mother_blood_pressure = bp;
      updatedFields.mother_blood_pressure = bp;
      anyApplied = true;
    }

    // Pulse rate (V009). Fill only when empty.
    if (this.isMotherParamEmpty(this.state.mother_pulse_rate) && vitals.V009 && vitals.V009 > 0) {
      updatedState.mother_pulse_rate = vitals.V009;
      updatedFields.mother_pulse_rate = vitals.V009;
      anyApplied = true;
    }

    // Weight in Kg (V002). Fill only when empty.
    if (this.isMotherParamEmpty(this.state.mother_weight) && vitals.V002 && vitals.V002 > 0) {
      updatedState.mother_weight = vitals.V002;
      updatedFields.mother_weight = vitals.V002;
      anyApplied = true;
    }

    // Mark the vital as applied even when nothing was filled, so we don't re-scan the
    // same snapshot on later prop refreshes.
    updatedState.vitalsApplied = true;

    if (anyApplied) {
      // Flag the change so the newly filled value is persisted on save/unmount.
      updatedState.mother_parameter_change_detected = true;
    }

    await this.setState(updatedState);
    if (anyApplied && this.obsGyaneFormRef.current) {
      this.obsGyaneFormRef.current.setFieldsValue(updatedFields);
    }
  }

  saveObsGyaneData = async() => {
    this.handleSaveObsGyaneData();
    this.handleSaveMenstrualHistory();
    this.handleSaveSexualHistory();
    this.handleSaveObstetricHistory();
    this.handleSaveMotherParameterData();
    this.handleSaveMotherFetusData();
  }

  // Validates every obs-gynae section. Returns { valid, message }.
  // Used by the parent (Print & Complete) to block completion when data is invalid.
  validateAllSections = async () => {
    if (!this.obsGyaneFormRef.current) return { valid: true, message: null };
    const allFields = [
      ...this.moduleFields.menstrual,
      ...this.moduleFields.sexual,
      ...this.moduleFields.obstetric,
      ...this.moduleFields.obsGyane,
      ...this.moduleFields.motherParameter,
    ];
    try {
      await this.obsGyaneFormRef.current.validateFields(allFields);
      // Fetal Heart Rate is mandatory for every fetus row.
      const invalidFetus = this.firstInvalidFetusHeartRate();
      if (invalidFetus > 0) {
        return { valid: false, message: 'Fetal Heart Rate is required for Fetus ' + invalidFetus + ' to proceed.' };
      }
      return { valid: true, message: null };
    } catch (err) {
      if (err && Array.isArray(err.errorFields) && err.errorFields.length > 0) {
        // Surface the first validation error message to the user.
        const first = err.errorFields[0];
        const msg = (first && first.errors && first.errors.length > 0) ? first.errors[0] : 'Please correct the highlighted Gynae & Obs fields to proceed.';
        return { valid: false, message: msg };
      }
      // Even when the antd fields validate, still enforce the FHR requirement.
      const invalidFetus = this.firstInvalidFetusHeartRate();
      if (invalidFetus > 0) {
        return { valid: false, message: 'Fetal Heart Rate is required for Fetus ' + invalidFetus + ' to proceed.' };
      }
      return { valid: true, message: null };
    }
  }

  // Public helper for the parent's "Close Pregnancy" guard: returns true only when
  // No. of Fetus holds a valid value (1-9). Reads the live form value first, falling
  // back to component state.
  isNoOfFetusFilled = () => {
    const formValue = this.obsGyaneFormRef.current?.getFieldValue('no_of_fetus');
    const value = (formValue !== undefined && formValue !== null && formValue !== '')
      ? formValue
      : this.state.no_of_fetus;
    return /^[1-9]$/.test(String(value ?? '').trim());
  }

  getPatientObsGyaneData = async () => {
    let Params = this.buildWhereCondition();
    await Axios.post(Get_Obs_Gyane_Data,Params).then(async res => {
      if(res.data.status == true)
      {
        /*********************** Menstural Data Fetch ****************************/
        // Pass the obs/gynae data as a fallback LMP source (derived from EDD By LMP) for
        // patients whose LMP is stored on the obs/gynae record but not in menstrual history.
        await this.applyMenstrualData(res.data?.data?.menstural_data, res.data?.data);

        /*********************** Sexual Data Fetch ****************************/
        await this.applySexualData(res.data?.data?.sexual_data);

        /*********************** Obstetric Data Fetch ****************************/
        await this.applyObstetricData(res.data?.data?.obstetric_data);

        /*********************** Obs Gyane Data Fetch ****************************/
        let obs_gyane_data = res.data?.data;
        if(obs_gyane_data)
        {
          if(obs_gyane_data?.pregnancy_risk_factor != null && obs_gyane_data?.pregnancy_risk_factor !== "")
          {
            let pregnancy_risk_factor_saved = obs_gyane_data?.pregnancy_risk_factor.split(',');
            let pregnancy_risk_factor_selected = [];
            for (var i = 0; i < pregnancy_risk_factor_saved.length; i++) {
                pregnancy_risk_factor_selected.push(parseInt(pregnancy_risk_factor_saved[i]));
            }
            await this.setState({
                pregnancy_risk_factor : pregnancy_risk_factor_selected,
                pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
            });
            await this.obsGyaneFormRef.current.setFieldsValue({
                pregnancy_risk_factor : pregnancy_risk_factor_selected,
                pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
            });
          }
          await this.setState({
            pregnant : obs_gyane_data?.pregnant || '0',
            lactating : obs_gyane_data?.lactating || '0',
            pregnancy_risk_factor_management_remarks : obs_gyane_data?.pregnancy_risk_factor_management_remarks || null,
            any_previous_complications : obs_gyane_data?.any_previous_complications || '0',
            any_previous_complication_details : (obs_gyane_data?.any_previous_complication_details && obs_gyane_data?.any_previous_complication_details != "" && obs_gyane_data?.any_previous_complication_details != null) ? obs_gyane_data.any_previous_complication_details.split(','): [],
            obstetric_remarks : obs_gyane_data?.obstetric_remarks || null,
          });

          await this.obsGyaneFormRef.current.setFieldsValue({
            pregnant : obs_gyane_data?.pregnant || '0',
            lactating : obs_gyane_data?.lactating || '0',
            pregnancy_risk_factor_management_remarks : obs_gyane_data?.pregnancy_risk_factor_management_remarks || null,
            any_previous_complications : obs_gyane_data?.any_previous_complications || '0',
            any_previous_complication_details : (obs_gyane_data?.any_previous_complication_details && obs_gyane_data?.any_previous_complication_details != "" && obs_gyane_data?.any_previous_complication_details != null) ? obs_gyane_data.any_previous_complication_details.split(','): [],
            obstetric_remarks : obs_gyane_data?.obstetric_remarks || null,
          });
        }

        if(obs_gyane_data.pregnant == "1")
        {
          // A reference id may have multiple mother-parameter rows (repeated saves).
          // If the API returns an array, use the latest (highest id); otherwise use the object as-is.
          let mother_parameter_data = res.data?.data?.mother_parameter_data;
          mother_parameter_data = this.pickLatestMotherParameter(mother_parameter_data);
          // Remember the fetched row's id so a subsequent save updates this exact row.
          const mother_parameter_id = mother_parameter_data?.id || null;

          /******************** Mother Fetus Data Fetch ******************************/
          // A reference id may also have multiple fetus batches accumulated. Each save
          // batch inserts `no_of_fetus` consecutive rows (ordered by id ASC from the API),
          // so the latest batch is the last `no_of_fetus` rows. Show only that batch.
          let mother_fetus_data = res.data?.data?.mother_fetus_data;
          let mother_fetal_parameters = [];
          if(Array.isArray(mother_fetus_data) && mother_fetus_data.length > 0)
          {
            const latest_fetus_batch = this.pickLatestFetusBatch(mother_fetus_data, obs_gyane_data?.no_of_fetus);
            latest_fetus_batch.forEach((ele, idx) => {
              // Keep each row's id so a subsequent save updates the same rows by id.
              // fetus_no identifies which fetus (1, 2, ...); fall back to position.
              let obj = { id: ele.id || null, fetus_no: (ele.fetus_no != null && ele.fetus_no !== '') ? ele.fetus_no : (idx + 1), fetal_movement: ele.fetal_movement, fetal_heart_rate: ele.fetal_heart_rate, presentation: ele.presentation, relationship_of_pp_to_brim: ele.relationship_of_pp_to_brim, head_cc: ele.head_cc, abdominal_cc: ele.abdominal_cc, femur_length: ele.femur_length }
              mother_fetal_parameters.push(obj);
            });
          }

          // Gestational age by USG is always derived from the Corrected EDD (recomputed for
          // "today"), so it stays correct on load instead of showing a stale saved value.
          const loaded_corrected_edd = (obs_gyane_data?.corrected_edd && obs_gyane_data.corrected_edd != null) ? moment(obs_gyane_data.corrected_edd).format('YYYY-MM-DD') : null;
          const loaded_usg_ga = this.getGestationalAgeFromEdd(loaded_corrected_edd);

          // No. of Fetus strictly reflects the actual count of fetus rows loaded (the latest
          // batch). When there is no fetal data, leave it empty (null) rather than showing a
          // stale stored value, since the field must match the fetal data present.
          const loaded_no_of_fetus = (mother_fetal_parameters.length > 0)
            ? mother_fetal_parameters.length
            : null;

          const gatedStateValues = {
            mother_parameter_id : mother_parameter_id,
            no_of_fetus : loaded_no_of_fetus,
            corrected_edd : loaded_corrected_edd,
            edd_by_lmp : (obs_gyane_data?.edd_by_lmp && obs_gyane_data.edd_by_lmp != null) ? moment(obs_gyane_data.edd_by_lmp).format('YYYY-MM-DD'): null,
            confirmed_by : (obs_gyane_data?.confirmed_by && obs_gyane_data?.confirmed_by != "" && obs_gyane_data?.confirmed_by != null) ? obs_gyane_data.confirmed_by.split(','): [],
            gestational_age_by_lmp_weeks : obs_gyane_data?.gestational_age_by_lmp_weeks,
            gestational_age_by_lmp_days : obs_gyane_data?.gestational_age_by_lmp_days,
            gestational_age_by_usg_days : (loaded_corrected_edd ? loaded_usg_ga.days : obs_gyane_data?.gestational_age_by_usg_days),
            gestational_age_by_usg_weeks : (loaded_corrected_edd ? loaded_usg_ga.weeks : obs_gyane_data?.gestational_age_by_usg_weeks),
            mother_pog : mother_parameter_data?.pog || null,
            mother_weight : mother_parameter_data?.weight || null,
            mother_blood_pressure : mother_parameter_data?.blood_pressure || null,
            mother_pulse_rate : mother_parameter_data?.pulse_rate || null,
            mother_fundal_height : mother_parameter_data?.fundal_height || null,
            mother_edema : mother_parameter_data?.edema || null,
            mother_pallor : mother_parameter_data?.pallor || null,
            mother_cervix_exam : mother_parameter_data?.cervix_exam || null,
            mother_preterm_labour : mother_parameter_data?.preterm_labour || null,
            mother_remarks : mother_parameter_data?.mother_remarks || null,
            mother_fetal_print_with_prescription : obs_gyane_data?.mother_fetal_print_with_prescription || '0',
            mother_fetal_parameters : mother_fetal_parameters,
          };

          // These fields are gated behind `pregnant === "1"` in render. Set state first,
          // then apply setFieldsValue in the state callback so the fields are mounted
          // before we push values into them (prevents intermittent blank fields).
          await new Promise(resolve => {
            this.setState(gatedStateValues, resolve);
          });

          this.obsGyaneFormRef.current.setFieldsValue({
            no_of_fetus : loaded_no_of_fetus,
            corrected_edd : loaded_corrected_edd ? moment(loaded_corrected_edd) : null,
            edd_by_lmp : (obs_gyane_data?.edd_by_lmp && obs_gyane_data.edd_by_lmp != null) ? moment(obs_gyane_data.edd_by_lmp): null,
            confirmed_by : (obs_gyane_data?.confirmed_by && obs_gyane_data?.confirmed_by != "" && obs_gyane_data?.confirmed_by != null) ? obs_gyane_data.confirmed_by.split(','): [],
            gestational_age_by_lmp_weeks : obs_gyane_data?.gestational_age_by_lmp_weeks,
            gestational_age_by_lmp_days : obs_gyane_data?.gestational_age_by_lmp_days,
            gestational_age_by_usg_days : (loaded_corrected_edd ? loaded_usg_ga.days : obs_gyane_data?.gestational_age_by_usg_days),
            gestational_age_by_usg_weeks : (loaded_corrected_edd ? loaded_usg_ga.weeks : obs_gyane_data?.gestational_age_by_usg_weeks),
            mother_pog : mother_parameter_data?.pog || null,
            mother_weight : mother_parameter_data?.weight || null,
            mother_blood_pressure : mother_parameter_data?.blood_pressure || null,
            mother_pulse_rate : mother_parameter_data?.pulse_rate || null,
            mother_fundal_height : mother_parameter_data?.fundal_height || null,
            mother_edema : mother_parameter_data?.edema || null,
            mother_pallor : mother_parameter_data?.pallor || null,
            mother_cervix_exam : mother_parameter_data?.cervix_exam || null,
            mother_preterm_labour : mother_parameter_data?.preterm_labour || null,
            mother_remarks : mother_parameter_data?.mother_remarks || null,
            mother_fetal_print_with_prescription : obs_gyane_data?.mother_fetal_print_with_prescription || '0',
            mother_fetal_parameters : mother_fetal_parameters,
          });
        }
        else
        {
          await this.setState({
            mother_parameter_id : null,
            mother_pog : null,
            no_of_fetus : null,
            corrected_edd : null,
            edd_by_lmp : null,
            confirmed_by : [],
            gestational_age_by_lmp_weeks : null,
            gestational_age_by_lmp_days : null,
            gestational_age_by_usg_days : null,
            gestational_age_by_usg_weeks : null,
            mother_pog : null,
            mother_weight : null,
            mother_blood_pressure : null,
            mother_pulse_rate : null,
            mother_fundal_height : null,
            mother_edema : null,
            mother_pallor : null,
            mother_cervix_exam : null,
            mother_preterm_labour : null,
            mother_fetal_parameters : [],
            mother_remarks : null,
            mother_fetal_print_with_prescription : '0'
          });
          await this.obsGyaneFormRef.current.setFieldsValue({
            mother_pog : null,
            no_of_fetus : null,
            corrected_edd : null,
            edd_by_lmp : null,
            gestational_age_by_lmp_weeks : null,
            gestational_age_by_lmp_days : null,
            gestational_age_by_usg_days : null,
            gestational_age_by_usg_weeks : null,
            mother_pog : null,
            mother_weight : null,
            mother_blood_pressure : null,
            mother_pulse_rate : null,
            mother_fundal_height : null,
            mother_edema : null,
            mother_pallor : null,
            mother_cervix_exam : null,
            mother_preterm_labour : null,
            mother_remarks : null,
            mother_fetal_print_with_prescription : '0'
          });
        }
        
      }
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to fetch the data',
        placement: 'topRight'
      })
    })
  }

  getPatientObsGyaneCopyStatus = async () => {
    let Params = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
    }
    await Axios.post(Get_Obs_Gyane_Copy_Status,Params).then(async res => {
      if(res.data.status == true)
      {
        await this.setState({
          prevPregnencyCopied : res.data.data.copy_prev_obs_gyane_status == '1' ? true : false
        })               
      }
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to fetch the data',
        placement: 'topRight'
      })
    })
  }

  getPatientPreviousObsGyaneData = async () => {
    let Params = this.buildWhereCondition();
    await Axios.post(Get_Previous_Obs_Gyane_Data,Params).then(async res => {
      if(res.data.status == true)
      {
        await this.setState({
          obsGynaePrevData : res.data.data
        })               
      }
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to fetch the data',
        placement: 'topRight'
      })
    })
  }
  
  async componentWillUnmount() {
    // The component unmounts when the user leaves the SOAP page by ANY route (left-panel side
    // menu, ANC card button, etc.). Dispatch the section saves here so pending edits persist.
    //
    // Snapshot the change flags first: React tears the component down synchronously, so reading
    // them up front avoids losing them mid-teardown. Fire the saves WITHOUT awaiting each one
    // sequentially — a slow antd validateFields() during teardown must not block the other
    // saves from dispatching their API requests before the page unmounts.
    const {
      menstrual_change_detected,
      sexual_change_detected,
      obstetric_change_detected,
      mother_parameter_change_detected,
      mother_fetus_change_detected,
      obs_gyane_change_detected,
    } = this.state;

    // Pass skipValidation on every unmount save: awaiting antd validateFields() during the
    // component's synchronous teardown can hang (the form instance detaches), which prevents
    // the Axios request from ever being dispatched — the root cause of obs/gynae data not
    // saving when leaving via the left-panel menu. Skipping validation lets each save fire its
    // API request immediately within the unmount tick.
    //
    // Persist the obs/gynae parent row whenever ANY section changed. Menstrual history is
    // stored in its own table but the obs/gynae parent row must exist for the record to be
    // complete, so a menstrual-only change also triggers the obs/gynae save.
    if (menstrual_change_detected || sexual_change_detected || obstetric_change_detected || mother_parameter_change_detected || mother_fetus_change_detected || obs_gyane_change_detected) {
      this.handleSaveObsGyaneData({ skipValidation: true });
    }
    // Menstrual history saves on its own change flag, independent of obs/gynae changes, so
    // adding ONLY menstrual data (e.g. LMP) still persists it.
    if (menstrual_change_detected) {
      this.handleSaveMenstrualHistory({ skipValidation: true });
    }
    if (sexual_change_detected) {
      this.handleSaveSexualHistory({ skipValidation: true });
    }
    if (obstetric_change_detected) {
      this.handleSaveObstetricHistory({ skipValidation: true });
    }
    if (mother_parameter_change_detected) {
      this.handleSaveMotherParameterData({ skipValidation: true });
    }
    if (mother_fetus_change_detected) {
      this.handleSaveMotherFetusData({ skipValidation: true });
    }
  }

  handleSaveMenstrualHistory = async ({ skipValidation = false } = {}) => {
    // Do not persist menstrual history if its own fields have validation errors.
    // On the normal path, use the antd form validation (validateFields).
    // On the unmount path (skipValidation=true), that async validation can hang during
    // teardown, so instead run a SYNCHRONOUS state-based check that mirrors the same rules
    // (menarch_age 7..patient age, bleeding_days 1..99, cycle_length 10..99). This still
    // prevents saving invalid data (e.g. an out-of-range menarch age) while guaranteeing the
    // API request dispatches when the data is valid.
    if (skipValidation) {
      if (!this.isMenstrualDataValidSync()) {
        return;
      }
    } else if (!(await this.isModuleValid('menstrual'))) {
      return;
    }
    let menstural_data = {
      menarch_age : this.state.menarch_age != "" ? this.state.menarch_age : null,
      regularity : this.state.regularity != "" ? this.state.regularity : null,
      flow : this.state.flow != "" ? this.state.flow : null,
      lmp : this.state.lmp != null ? moment(this.state.lmp).format('YYYY-MM-DD') : null,
      bleeding_days : this.state.bleeding_days != "" ? this.state.bleeding_days : null,
      cycle_length : this.state.cycle_length != "" ? this.state.cycle_length : null,
      menstrual_remarks : this.state.menstrual_remarks,
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }

    let Params = {
      where_condition: this.buildWhereCondition(),
      menstural_data,
    }
    // Snapshot the LMP being saved (and the previously-saved one) so we can audit a genuine
    // change. Capture these BEFORE dispatching so the values are stable even if the component
    // unmounts mid-save.
    const newLmp = menstural_data.lmp;
    const previousLmp = this.state.last_saved_lmp;
    // Dispatch the LMP audit INDEPENDENTLY of the menstrual-history save rather than chaining
    // it inside the save's .then(). The audit writes to its own table and only needs the
    // previous/new LMP, so chaining it caused the first-time audit to be missed when the
    // menstrual save was fired without awaiting (unmount path / saveObsGyaneData) and the
    // page navigated before the save's .then() ran. Firing it alongside guarantees the audit
    // POST dispatches on the first save too. Same-LMP / empty-LMP cases are no-ops inside it.
    this.saveLmpAuditIfChanged(previousLmp, newLmp);
    await Axios.post(Save_Menstrual_History,Params).then(async res => {
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  // Writes an LMP audit entry only when the LMP has genuinely changed from the previously
  // saved value. If previous and new are the same (or new is empty), nothing is saved.
  // Called after the menstrual history is persisted (LMP lives in menstrual history).
  saveLmpAuditIfChanged = async (previousLmp, newLmp) => {
    const prev = previousLmp ? moment(previousLmp).format('YYYY-MM-DD') : null;
    const next = newLmp ? moment(newLmp).format('YYYY-MM-DD') : null;
    // No LMP to record, or unchanged => do not create an audit entry.
    if (!next) return;
    if (prev === next) {
      return;
    }
    try {
      await Axios.post(Save_Lmp_Audit, {
        patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
        reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
        reference_type: LS_SERVICE.get('reference_type'),
        hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
        enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
        source: 'OP',
        previous_lmp: prev,
        new_lmp: next,
        // No explicit reason is captured for a plain LMP change from the menstrual field.
        reason: prev ? 'LMP updated' : 'LMP recorded',
        changed_by: LS_SERVICE.get('staff_id'),
        changed_by_name: LS_SERVICE.get('profile')?.data?.full_name || ("Dr. " + LS_SERVICE.get('staff_name')),
        audit_date: moment().format('YYYY-MM-DD HH:mm:ss'),
      });
      // Update the baseline so a subsequent unchanged save does not re-audit.
      await this.setState({ last_saved_lmp: next });
      // Refresh the LMP audit log so the new entry shows immediately.
      this.getLmpAudit();
    } catch (err) {
      // Non-blocking: the LMP audit is informational; a failure must not block the save.
    }
  }

  handleSaveSexualHistory = async ({ skipValidation = false } = {}) => {
    // Do not persist sexual history if its own fields have validation errors.
    // skipValidation is used on unmount so the save dispatches without awaiting validateFields.
    if (!skipValidation && !(await this.isModuleValid('sexual'))) {
      return;
    }
    let sexual_data = {
      sexually_active : this.state.sexually_active,
      marital_status : this.state.marital_status,
      spouse_name : (this.state.marital_status == '2' && this.state.spouse_name != "") ? this.state.spouse_name : null,
      since : this.state.since != "" ? this.state.since : null,
      since_by : this.state.since_by || 4,
      married_life : this.state.married_life,
      contraceptives : this.state.contraceptives.length > 0 ? this.state.contraceptives.toString(): null,
      contraceptive_remarks : this.state.contraceptive_remarks,
      remarks : this.state.remarks,
      sexual_history_data_confidential : this.state.sexual_history_data_confidential,
      remarks_confidential : this.state.remarks_confidential,
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }

    let Params = {
      where_condition: this.buildWhereCondition(),
      sexual_data,
    }
    await Axios.post(Save_Sexual_History,Params).then(async res => {
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleSaveObstetricHistory = async ({ skipValidation = false } = {}) => {
    // Do not persist obstetric history if its own fields have validation errors.
    // On the normal path use the antd form validation; on the unmount path (skipValidation),
    // use the synchronous state-based obstetric validator so invalid interdependent values
    // (e.g. Parity != Term+Pre-term+Still Birth) are still not persisted, while valid data
    // saves reliably without awaiting validateFields during teardown.
    if (skipValidation) {
      if (!this.isObstetricDataValidSync()) {
        return;
      }
    } else if (!(await this.isModuleValid('obstetric'))) {
      return;
    }
    let obstetric_data = {
      gravidity : this.state.gravidity != "" ? this.state.gravidity : null,
      parity : this.state.parity != "" ? this.state.parity : null,
      abortion : this.state.abortion != "" ? this.state.abortion : null,
      live_birth : this.state.live_birth != "" ? this.state.live_birth : null,
      ectopic : this.state.ectopic != "" ? this.state.ectopic : null,
      lscs : this.state.lscs != "" ? this.state.lscs : null,
      miscarriage : this.state.miscarriage != "" ? this.state.miscarriage : null,
      mtp : this.state.mtp != "" ? this.state.mtp : null,
      preterm : this.state.preterm != "" ? this.state.preterm : null,
      term : this.state.term != "" ? this.state.term : null,
      still_birth : this.state.still_birth != "" ? this.state.still_birth : null,
      confidential : this.state.obstetric_data_confidential,
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }

    let Params = {
      where_condition: this.buildWhereCondition(),
      obstetric_data,
    }
    await Axios.post(Save_Obstetric_History,Params).then(async res => {
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleSaveObsGyaneData = async ({ skipValidation = false } = {}) => {
    // Do not persist obs gyane data if its own fields have validation errors.
    // skipValidation is used when only the pregnant flag must be persisted (e.g. marking
    // pregnant), where No. of Fetus has not been entered yet and must not block the save.
    if (!skipValidation && !(await this.isModuleValid('obsGyane'))) {
      return;
    }
    let obs_gyane_data = {
      pregnant : this.state.pregnant,
      edd_by_lmp : this.state.pregnant == "1" ? this.state.edd_by_lmp : null,
      corrected_edd : this.state.pregnant == "1" ? this.state.corrected_edd : null,
      lactating : this.state.lactating,
      confirmed_by : (this.state.confirmed_by.length > 0 && this.state.pregnant == "1") ? this.state.confirmed_by.toString(): null,
      gestational_age_by_lmp_weeks : this.state.pregnant == "1" ? ((this.state.gestational_age_by_lmp_weeks !== "" && this.state.gestational_age_by_lmp_weeks !== null && this.state.gestational_age_by_lmp_weeks !== undefined) ? this.state.gestational_age_by_lmp_weeks : null) : null,
      gestational_age_by_lmp_days : this.state.pregnant == "1" ? ((this.state.gestational_age_by_lmp_days !== "" && this.state.gestational_age_by_lmp_days !== null && this.state.gestational_age_by_lmp_days !== undefined) ? this.state.gestational_age_by_lmp_days : null) : null,
      gestational_age_by_usg_weeks: this.state.pregnant == "1" ? ((this.state.gestational_age_by_usg_weeks !== "" && this.state.gestational_age_by_usg_weeks !== null && this.state.gestational_age_by_usg_weeks !== undefined) ? this.state.gestational_age_by_usg_weeks : null) : null,
      gestational_age_by_usg_days : this.state.pregnant == "1" ? ((this.state.gestational_age_by_usg_days !== "" && this.state.gestational_age_by_usg_days !== null && this.state.gestational_age_by_usg_days !== undefined) ? this.state.gestational_age_by_usg_days : null) : null,
      pregnancy_risk_factor : this.state.pregnancy_risk_factor.length > 0 ? this.state.pregnancy_risk_factor.toString(): null,
      pregnancy_risk_factor_management_remarks : this.state.pregnancy_risk_factor_management_remarks,
      any_previous_complications : this.state.any_previous_complications,
      any_previous_complication_details : this.state.any_previous_complication_details.length > 0 ? this.state.any_previous_complication_details.toString(): null,
      obstetric_remarks : this.state.obstetric_remarks,
      no_of_fetus : this.state.pregnant == "1" ? this.state.no_of_fetus != "" ? this.state.no_of_fetus : null : null,
      mother_fetal_print_with_prescription : this.state.mother_fetal_print_with_prescription || '0',
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }

    let Params = {
      where_condition: this.buildWhereCondition(),
      obs_gyane_data,
    }
    await Axios.post(Save_Obs_Gyane_Data,Params).then(async res => {
      // Reflect the lactating flag live on the left panel (same pattern as the pregnant flag).
      const lactatingFlag = this.state.lactating == "1" ? "1" : "0";
      LS_SERVICE.set('PATIENT_LACTATING_STATUS', lactatingFlag);
      lactatingService.init({ is_lactating: lactatingFlag });
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleSaveMotherParameterData = async ({ skipValidation = false } = {}) => {
    // Do not persist mother parameters if its own fields have validation errors.
    // skipValidation is used on unmount so the save dispatches without awaiting validateFields.
    if (!skipValidation && !(await this.isModuleValid('motherParameter'))) {
      return;
    }
    let mother_parameter_data = {
      pog : this.state.pregnant == "1" ? this.state.mother_pog != "" ? this.state.mother_pog : null : null,
      weight : this.state.pregnant == "1" ? this.state.mother_weight != "" ? this.state.mother_weight : null : null,
      blood_pressure : this.state.pregnant == "1" ? this.state.mother_blood_pressure != "" ? this.state.mother_blood_pressure : null : null,
      pulse_rate : this.state.pregnant == "1" ? this.state.mother_pulse_rate != "" ? this.state.mother_pulse_rate : null : null,
      fundal_height : this.state.pregnant == "1" ? this.state.mother_fundal_height != "" ? this.state.mother_fundal_height : null : null,
      edema : this.state.pregnant == "1" ? this.state.mother_edema != "" ? this.state.mother_edema : null : null,
      pallor : this.state.pregnant == "1" ? this.state.mother_pallor != "" ? this.state.mother_pallor : null : null,
      cervix_exam : this.state.pregnant == "1" ? this.state.mother_cervix_exam != "" ? this.state.mother_cervix_exam : null : null,
      preterm_labour : this.state.pregnant == "1" ? this.state.mother_preterm_labour != "" ? this.state.mother_preterm_labour : null : null,
      mother_remarks : this.state.pregnant == "1" ? this.state.mother_remarks : null,
      // When set, the backend updates this exact fetched row (by id) instead of
      // inserting a new duplicate; null means create a fresh row.
      id : this.state.mother_parameter_id || null,
      // Track who saved the mother parameters: doctor id and full name including title
      // (e.g. "Dr. John Doe"); falls back to "Dr. " + staff_name when profile is absent.
      saved_by_doctor_id : LS_SERVICE.get('staff_id'),
      saved_by_doctor_name : LS_SERVICE.get('profile')?.data?.full_name || ("Dr. " + LS_SERVICE.get('staff_name')),
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }

    let Params = {
      where_condition: this.buildWhereCondition(),
      mother_parameter_data,
    }
    await Axios.post(Save_Mother_Parameter_Data,Params).then(async res => {
      // Capture the id returned by the backend so the next save updates this same row.
      if (res?.data?.id) {
        await this.setState({ mother_parameter_id: res.data.id });
      }
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleSaveMotherFetusData = async ({ skipValidation = false } = {}) => {
    // Do not persist fetus data if its validation (No. of Fetus) fails.
    // On the normal path use the antd form validation; on the unmount path use the synchronous
    // No. of Fetus check (1-9, required when pregnant) so invalid data is not persisted while
    // still dispatching the save for valid data without awaiting validateFields during teardown.
    if (skipValidation) {
      if (!this.isNoOfFetusValidSync()) {
        return;
      }
    } else if (!(await this.isModuleValid('motherFetus'))) {
      return;
    }
    // Fetal Heart Rate is mandatory for every fetus before saving fetus data. This is a
    // synchronous state check (no form validation), so it is safe to keep even on unmount.
    if (!this.isFetusHeartRateValid()) {
      return;
    }
    let mother_fetus_data = {
      mother_fetal_parameters : this.state.pregnant == "1" ? this.state.mother_fetal_parameters : [],
      // Track who saved the fetus details: doctor id and full name including title
      // (e.g. "Dr. John Doe"); falls back to "Dr. " + staff_name when profile is absent.
      saved_by_doctor_id : LS_SERVICE.get('staff_id'),
      saved_by_doctor_name : LS_SERVICE.get('profile')?.data?.full_name || ("Dr. " + LS_SERVICE.get('staff_name')),
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }

    let Params = {
      where_condition: this.buildWhereCondition(),
      mother_fetus_data,
    }
    await Axios.post(Save_Mother_Fetus_Data,Params).then(async res => {
      // Backend returns the persisted rows (with ids) in save order; sync them back so
      // the next save updates the same rows by id instead of inserting duplicates.
      if (Array.isArray(res?.data?.data) && res.data.data.length > 0) {
        await this.setState(prevState => {
          const updated = prevState.mother_fetal_parameters.map((item, idx) => (
            res.data.data[idx]?.id ? { ...item, id: res.data.data[idx].id } : item
          ));
          return { mother_fetal_parameters: updated };
        });
      }
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  // Returns the patient's age in years (or null when unavailable).
  getPatientAgeYears = () => {
    const a = this.state.patient_dob;
    if (a === '' || a === null || a === undefined) return null;
    const n = parseInt(a);
    return isNaN(n) ? null : n;
  };

  // Max allowed "Since" value for the given unit, derived from the patient's age so the
  // duration can never exceed how long the patient has been alive. Days/Weeks/Months are
  // converted from the age-in-years cap. Returns { max, unitLabel } (max is null when the age
  // is unknown, so no cap is applied).
  getSinceMaxForUnit = (sinceBy) => {
    const ageYears = this.getPatientAgeYears();
    if (ageYears === null) return { max: null, unitLabel: null };
    switch (parseInt(sinceBy)) {
      case 1: return { max: ageYears * 365, unitLabel: 'days' };
      case 2: return { max: ageYears * 52, unitLabel: 'weeks' };
      case 3: return { max: ageYears * 12, unitLabel: 'months' };
      case 4:
      default: return { max: ageYears, unitLabel: 'years' };
    }
  };

  handleOnNumberChange = async(event) => {
    const { name, value } = event.currentTarget;
    let regex_aplhabet = /[0-9?]/
    const isValidNumber = regex_aplhabet.test(value);
    if(!isValidNumber && value != '')
    {
      return false;
    }
    // "Since" (how long sexually active) cannot exceed how long the patient has been alive.
    // The cap depends on the selected unit (Days/Weeks/Months/Years), derived from the
    // patient's age. Reject the over-limit value BEFORE committing it to state (keep the field
    // at its previous value) and inform the user, so the invalid value never lands in state.
    if (name === "since") {
      const { max, unitLabel } = this.getSinceMaxForUnit(this.state.since_by);
      if (max !== null && value !== '' && parseInt(value) > max) {
        notification.error({
          message: `Since cannot be greater than ${max} ${unitLabel} (the patient's age).`,
          placement: 'topRight'
        });
        // Restore the field to the last valid value so the invalid entry is not accepted.
        await this.obsGyaneFormRef.current.setFieldsValue({ since: this.state.since });
        return;
      }
    }
    await this.setState({
      [name]: value
    });

    if(name == "menarch_age" || name == "bleeding_days" || name == "cycle_length")
    {
      await this.setState({
        menstrual_change_detected : true
      })
    }
    if(name == "since")
    {
      // Validity (Since <= patient's age for the selected unit) is enforced up front, so here
      // we only flag the change.
      await this.setState({
        sexual_change_detected : true
      })
    }
    if(name == "gestational_age_by_lmp_weeks" || name == "gestational_age_by_lmp_days" || name == "gestational_age_by_usg_weeks" || name == "gestational_age_by_usg_days")
    {
      await this.setState({
        obs_gyane_change_detected : true
      })
    }
    const isObstetricField = (name == "gravidity" || name == "parity" || name == "abortion" || name == "live_birth" || name == "ectopic" || name == "lscs" || name == "miscarriage" || name == "mtp" || name == "preterm" || name == "term" || name == "still_birth");
    if(isObstetricField)
    {
      await this.setState({
        obstetric_change_detected : true
      })
    }

    await this.obsGyaneFormRef.current.setFieldsValue({
      [name]: value
    });

    // Obstetric fields are interdependent (e.g. Parity = Term + Pre-term + Still Birth,
    // Gravida >= Parity + Abortion). Re-validate the whole obstetric group so an edit to
    // one field refreshes the errors on all fields that depend on it.
    if(isObstetricField)
    {
      this.obsGyaneFormRef.current.validateFields(this.moduleFields.obstetric).catch(() => {});
    }
  }

  onSelectChange = async (value, props, field, index) => {
    await this.setState({
      [field]: value,
      menstrual_change_detected : true
    });
    await this.obsGyaneFormRef.current.setFieldsValue({
      [field]: value
    });
  }

  onSelectSinceByChange = async (event) => {
    const { value } = event.currentTarget;
    // Changing the unit can make the current "Since" value exceed the new unit's cap
    // (e.g. 40 is valid as Months but not as Years for a 30y patient). Clear the value and
    // warn the user when that happens, so an out-of-range duration is never kept.
    const { max, unitLabel } = this.getSinceMaxForUnit(value);
    let nextSince = this.state.since;
    if (max !== null && nextSince !== null && nextSince !== '' && parseInt(nextSince) > max) {
      nextSince = null;
      notification.error({
        message: `Since cannot be greater than ${max} ${unitLabel} (the patient's age). The value has been cleared.`,
        placement: 'topRight'
      });
    }
    await this.setState({ since_by: value, since: nextSince, sexual_change_detected : true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      since_by: value,
      since: nextSince,
    });
  }

  handleSexualDataConfidentialChange = async (e) => {
    const checked = e.target.checked;
    const value = checked ? '1' : '0';

    await this.setState({ sexual_history_data_confidential: value, sexual_change_detected : true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      sexual_history_data_confidential: value
    });
  }

  handleObsterticDataConfidentialChange = async (e) => {
    const checked = e.target.checked;
    const value = checked ? '1' : '0';

    await this.setState({ obstetric_data_confidential: value, obstetric_change_detected: true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      obstetric_data_confidential: value
    });
  }

  handleMotherFetalPrintWithPrescription = async (e) => {
    const checked = e.target.checked;
    const value = checked ? '1' : '0';

    await this.setState({ mother_fetal_print_with_prescription: value });
    await this.obsGyaneFormRef.current.setFieldsValue({
      mother_fetal_print_with_prescription: value
    });
  }

  handleLactatingChange = async (e) => {
    const value = e.target.value;

    await this.setState({ lactating: value, obs_gyane_change_detected : true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      lactating: value
    });

    // Reflect the lactating flag on the left panel immediately when toggled (before save),
    // same as the pregnant flag behaviour.
    const lactatingFlag = value == "1" ? "1" : "0";
    LS_SERVICE.set('PATIENT_LACTATING_STATUS', lactatingFlag);
    lactatingService.init({ is_lactating: lactatingFlag });
  }

  handleSexualRemarksConfidentialChange = async (e) => {
    const checked = e.target.checked;
    const value = checked ? '1' : '0';

    await this.setState({ remarks_confidential: value , sexual_change_detected : true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      remarks_confidential: value
    });
  }

  handleOnTextChange = async(event) => {
    const { name, value } = event.currentTarget;
    await this.setState({
      [name]: value
    });
    if(name == "menstrual_remarks")
    {
      await this.setState({
        menstrual_change_detected : true
      })
    }
    if(name == "married_life" || name == "contraceptive_remarks" || name == "remarks" || name == "spouse_name")
    {
      await this.setState({
        sexual_change_detected : true
      })
    }
    if(name == "pregnancy_risk_factor_management_remarks" || name == "obstetric_remarks")
    {
      await this.setState({
        obs_gyane_change_detected : true
      })
    }
    if(name == "mother_pog" || name == "mother_weight" || name == "mother_blood_pressure" || name == "mother_pulse_rate" || name == "mother_fundal_height" || name == "mother_edema" || name == "mother_pallor" || name == "mother_cervix_exam" || name == "mother_preterm_labour" || name == "mother_remarks")
    {
      await this.setState({
        mother_parameter_change_detected : true
      })
    }
    await this.obsGyaneFormRef.current.setFieldsValue({
      [name]: value
    });
  }

  onChangeRadioCheck = async (event) => {
    const value = event.target.value;
    // When Sexually Active is set to No ('0'), clear the dependent "Since" fields so a
    // previously entered value doesn't linger (and isn't saved) after the change.
    const isYes = value === '1';
    await this.setState({
        sexually_active: value,
        since: isYes ? this.state.since : null,
        // Reset the unit back to the default (Years) when clearing.
        since_by: isYes ? this.state.since_by : 4,
        sexual_change_detected : true
    });

    await this.obsGyaneFormRef.current.setFieldsValue({
      sexually_active : value,
      since: isYes ? this.state.since : null,
      since_by: isYes ? this.state.since_by : 4,
    });
  }

  onChangeMaritalStatus = async (event) => {
    const value = event.target.value;
    const isMarried = value === '2';
    await this.setState({
        marital_status: value,
        // Clear Married-only fields when switching away from Married, so previously entered
        // values (Spouse Name, Married Life) don't linger (and aren't saved) when it is set
        // back to Married later.
        spouse_name: isMarried ? this.state.spouse_name : null,
        married_life: isMarried ? this.state.married_life : null,
        sexual_change_detected : true
    });

    await this.obsGyaneFormRef.current.setFieldsValue({
      marital_status : value,
      spouse_name : isMarried ? this.state.spouse_name : null,
      married_life : isMarried ? this.state.married_life : null,
    });
  }

  handleLmpDateChange = async (date, dateString, field) => {
    
    let gestational_age_by_lmp_weeks = null;
    let gestational_age_by_lmp_days = null;
    let edd_by_lmp = null;
    await this.setState({
      [field]: moment(date).format("YYYY-MM-DD"),
      menstrual_change_detected : true
    }, async () => {
      // Count WHOLE calendar days (both dates at start-of-day) and use floor, so the GA
      // matches the ANC card's getGAToday exactly (no time-of-day/rounding drift, e.g.
      // 02 Oct -> 05 Oct is 0w 3d, not 0w 4d). Parse as DATE-ONLY so timezone can't shift it.
      const totalDays = moment(moment().format('YYYY-MM-DD')).diff(moment(moment(this.state.lmp).format('YYYY-MM-DD')), 'days');
      gestational_age_by_lmp_weeks = Math.floor(totalDays / 7);
      gestational_age_by_lmp_days = totalDays % 7;
      if(gestational_age_by_lmp_weeks < 0 )
      {
        gestational_age_by_lmp_weeks = 0
      }
      if(gestational_age_by_lmp_days < 0 )
      {
        gestational_age_by_lmp_days = 0
      }
      edd_by_lmp = moment(this.state.lmp).add(40, 'weeks').format("YYYY-MM-DD");
      await this.setState({
        gestational_age_by_lmp_weeks : gestational_age_by_lmp_weeks,
        gestational_age_by_lmp_days : gestational_age_by_lmp_days,
        mother_pog : gestational_age_by_lmp_weeks,
        edd_by_lmp : moment(edd_by_lmp).format("YYYY-MM-DD"),
      });
      await this.obsGyaneFormRef.current.setFieldsValue({
        mother_pog: gestational_age_by_lmp_weeks,
        gestational_age_by_lmp_weeks: gestational_age_by_lmp_weeks,
        gestational_age_by_lmp_days: gestational_age_by_lmp_days,
        edd_by_lmp : moment(edd_by_lmp),
      });
    });
  }

  onChangePregnantCheck = async (event) => {
    const value = event.target.value;
    // Pregnant = Yes requires LMP to be filled first. Block the selection otherwise.
    if (value === "1" && (this.state.lmp === null || this.state.lmp === "")) {
      notification.error({
        message: 'Please fill LMP first',
        placement: 'topRight'
      });
      // Keep the radio on "No" (do not accept the change).
      await this.setState({ pregnant: "0" });
      this.obsGyaneFormRef.current.setFieldsValue({ pregnant: "0" });
      return;
    }
    // Marking the patient pregnant needs explicit confirmation. Hold the radio on its
    // current value and open a confirmation popup; apply only if the user confirms.
    if (value === "1") {
      this.obsGyaneFormRef.current.setFieldsValue({ pregnant: this.state.pregnant });
      this.setState({ pregnantConfirmVisible: true });
      return;
    }
    // Selecting "No" applies immediately.
    await this.applyPregnantChange(value);
  }

  confirmPregnant = async () => {
    await this.setState({ pregnantConfirmVisible: false });
    await this.applyPregnantChange("1");
    // Set the patient-level Patient.is_pregnant flag ONCE via the dedicated endpoint (which
    // also opens the ANC card). This is decoupled from handleSaveObsGyaneData so later
    // obs/gynae re-saves (e.g. on Print & Complete, after the pregnancy is closed) never
    // re-flip the status back to pregnant.
    await this.updatePatientPregnantStatus("1");
    // Persist the obs/gynae data. Skip validation: marking pregnant precedes entering
    // No. of Fetus, so the required No. of Fetus rule must not block the save.
    await this.handleSaveObsGyaneData({ skipValidation: true });
    // Marking pregnant only reveals the Mother & Fetal Parameters section; the user has
    // not filled No. of Fetus yet, so clear the required-field errors that the save's
    // validateFields painted. Real validation still runs on the user's own save.
    this.clearObsGyaneValidationErrors();
    // Record a dedicated audit entry for marking the patient pregnant.
    // (PATIENT_PREGNANT_STATUS persistence + live sidebar broadcast are handled in
    // applyPregnantChange, called above.)
    this.savePregnantAudit();
    // Note: the LMP audit is NOT written here. It is recorded by handleSaveMenstrualHistory
    // (via saveLmpAuditIfChanged) whenever the LMP actually changes, so marking pregnant does
    // not create a redundant LMP audit for an unchanged LMP.
  }

  // Sets the patient-level is_pregnant flag on the backend via the dedicated endpoint.
  // Called once when the user confirms "Pregnant = Yes". The endpoint also opens an ANC
  // card so subsequent obs/gynae saves don't need to (and don't) touch the pregnancy flag.
  updatePatientPregnantStatus = async (is_pregnant) => {
    const params = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      is_pregnant: is_pregnant,
    };
    await Axios.post(Update_Patient_Pregnant_Status, params)
      .catch(error => {
        notification.error({
          message: 'Something went wrong! Unable to update the pregnancy status',
          placement: 'topRight'
        });
      });
  }

  // Saves a dedicated audit record for the "marked pregnant" action:
  // date, doctor name, reference id/type, source, patient id, doctor id.
  savePregnantAudit = async () => {
    const params = {
      audit_date: moment().format('YYYY-MM-DD HH:mm:ss'),
      doctor_id: LS_SERVICE.get('staff_id'),
      // Full name including title (e.g. "Dr. John Doe"); falls back to "Dr. " + staff_name.
      doctor_name: LS_SERVICE.get('profile')?.data?.full_name || ("Dr. " + LS_SERVICE.get('staff_name')),
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: LS_SERVICE.get('reference_type'),
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      source: 'OP',
    };
    await Axios.post(Save_Pregnant_Audit, params)
      .then(() => {
        // Refresh the audit list so the newly added entry shows after Corrected EDD.
        this.getPregnantAudit();
      })
      .catch(error => {
        notification.error({
          message: 'Something went wrong! Unable to save the pregnancy audit',
          placement: 'topRight'
        });
      });
  }

  // Fetches the pregnancy audit entries for this patient visit.
  getPregnantAudit = async () => {
    const params = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
    };
    await Axios.post(Get_Pregnant_Audit, params)
      .then(res => {
        if (res.data.status === true) {
          this.setState({ pregnantAuditData: res.data.data || [] });
        }
      })
      .catch(error => {
        // Non-blocking: audit display is informational only.
      });
  }

  cancelPregnant = async () => {
    // User declined: keep the patient as not pregnant.
    await this.setState({ pregnantConfirmVisible: false, pregnant: "0" });
    this.obsGyaneFormRef.current.setFieldsValue({ pregnant: "0" });
  }

  /*********************** EDIT LMP (when pregnant) ***********************/

  // Open the Edit LMP popup, pre-filling the new-LMP picker with the current LMP.
  openLmpEdit = () => {
    this.setState({
      lmpEditModalVisible: true,
      lmpEditNewDate: this.state.lmp ? moment(this.state.lmp) : null,
      lmpEditReason: '',
    });
  }

  cancelLmpEdit = () => {
    this.setState({ lmpEditModalVisible: false, lmpEditNewDate: null, lmpEditReason: '' });
  }

  handleLmpEditDateChange = (date) => {
    this.setState({ lmpEditNewDate: date || null });
  }

  handleLmpEditReasonChange = (e) => {
    this.setState({ lmpEditReason: e.target.value });
  }

  // Confirm the LMP change: validate, save a dedicated audit (previous/new LMP + reason),
  // then update LMP + recalc EDD/GA, persist, and re-disable the LMP field.
  confirmLmpEdit = async () => {
    const newDate = this.state.lmpEditNewDate;
    const reason = (this.state.lmpEditReason || '').trim();

    if (!newDate) {
      notification.error({ message: 'Please select the new LMP date', placement: 'topRight' });
      return;
    }
    if (reason === '') {
      notification.error({ message: 'Please enter a reason for changing the LMP', placement: 'topRight' });
      return;
    }

    await this.setState({ lmpEditSaving: true });

    const previousLmp = this.state.lmp ? moment(this.state.lmp).format('YYYY-MM-DD') : null;
    const newLmp = moment(newDate).format('YYYY-MM-DD');

    // 1) Save the LMP-change audit (previous LMP, new LMP, changed by, reason).
    try {
      await Axios.post(Save_Lmp_Audit, {
        patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
        reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
        reference_type: LS_SERVICE.get('reference_type'),
        hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
        enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
        source: 'OP',
        previous_lmp: previousLmp,
        new_lmp: newLmp,
        reason: reason,
        changed_by: LS_SERVICE.get('staff_id'),
        changed_by_name: LS_SERVICE.get('profile')?.data?.full_name || ("Dr. " + LS_SERVICE.get('staff_name')),
        audit_date: moment().format('YYYY-MM-DD HH:mm:ss'),
      });
    } catch (err) {
      notification.error({ message: 'Something went wrong! Unable to save the LMP audit', placement: 'topRight' });
      await this.setState({ lmpEditSaving: false });
      return;
    }

    // 2) Update LMP and recompute GA + EDD (same math as handleLmpDateChange).
    // Whole calendar days + floor, matching the ANC card's getGAToday so GA is consistent
    // across screens. Parse as DATE-ONLY so a time/timezone component can't shift the day.
    const totalDays = moment(moment().format('YYYY-MM-DD')).diff(moment(moment(newLmp).format('YYYY-MM-DD')), 'days');
    let ga_weeks = Math.floor(totalDays / 7);
    let ga_days = totalDays % 7;
    if (ga_weeks < 0) { ga_weeks = 0; ga_days = 0; }
    const edd = moment(newLmp).add(40, 'weeks').format('YYYY-MM-DD');

    await this.setState({
      lmp: newLmp,
      // This flow already wrote its own LMP audit (with the user's reason) above, so update
      // the baseline to the new LMP. This prevents handleSaveMenstrualHistory from writing a
      // second, duplicate audit for the same change on a later save/unmount.
      last_saved_lmp: newLmp,
      gestational_age_by_lmp_weeks: ga_weeks,
      gestational_age_by_lmp_days: ga_days,
      mother_pog: ga_weeks,
      edd_by_lmp: edd,
      menstrual_change_detected: true,
      lmpEditModalVisible: false,
      lmpEditSaving: false,
      lmpEditReason: '',
      lmpEditNewDate: null,
    });
    this.obsGyaneFormRef.current.setFieldsValue({
      lmp: moment(newLmp),
      mother_pog: ga_weeks,
      gestational_age_by_lmp_weeks: ga_weeks,
      gestational_age_by_lmp_days: ga_days,
      edd_by_lmp: moment(edd),
    });

    // 3) Persist the obs/gynae data so the new LMP/EDD are saved, then refresh the audit log.
    await this.handleSaveObsGyaneData({ skipValidation: true });
    this.getLmpAudit();
    notification.success({ message: 'LMP updated successfully', placement: 'topRight' });
  }

  // Fetches the LMP-change audit entries for this patient visit.
  getLmpAudit = async () => {
    const params = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
    };
    await Axios.post(Get_Lmp_Audit, params)
      .then(res => {
        if (res.data.status === true) {
          this.setState({ lmpAuditData: res.data.data || [] });
        }
      })
      .catch(() => {
        // Non-blocking: audit display is informational only.
      });
  }

  applyPregnantChange = async (value) => {
    const flag = value === "1" ? "1" : "0";
    // Persist the patient-level pregnancy flag so other screens (ANC card header badge,
    // left sidebar) reflect the correct status, and broadcast it live so the sidebar
    // updates without a reload. Single source of truth for both Yes and No.
    LS_SERVICE.set('PATIENT_PREGNANT_STATUS', flag);
    pregnantService.init({ is_pregnant: flag });
    let gestational_age_by_lmp_weeks = null;
    let gestational_age_by_lmp_days = null;
    let edd_by_lmp = null;
    await this.setState({
      pregnant: value,
      obs_gyane_change_detected : true,
      mother_parameter_change_detected : true,
      mother_fetus_change_detected : true,
      // Marking pregnant with an LMP already present means the LMP must persist (and be
      // audited) on save. Flag a menstrual change so the unmount/save guard runs the menstrual
      // history save (which dispatches the LMP audit) — otherwise the first-time LMP audit was
      // skipped when the LMP wasn't entered via the menstrual LMP field itself.
      menstrual_change_detected : (value === "1" && this.state.lmp != null) ? true : this.state.menstrual_change_detected,
    }, async () => {
      if(this.state.pregnant == "1" && this.state.lmp != null)
      {
        // Whole calendar days + floor, matching the ANC card's getGAToday. Parse as DATE-ONLY
        // so a time/timezone component on the LMP can't shift the day and inflate GA.
        const totalDays = moment(moment().format('YYYY-MM-DD')).diff(moment(moment(this.state.lmp).format('YYYY-MM-DD')), 'days');
        gestational_age_by_lmp_weeks = Math.floor(totalDays / 7);
        gestational_age_by_lmp_days = totalDays % 7;
        if(gestational_age_by_lmp_weeks < 0 )
        {
          gestational_age_by_lmp_weeks = 0;
          gestational_age_by_lmp_days = 0;
        }
        edd_by_lmp = moment(this.state.lmp).add(40, 'weeks').format("YYYY-MM-DD");
        await this.setState({
          gestational_age_by_lmp_weeks : gestational_age_by_lmp_weeks,
          gestational_age_by_lmp_days : gestational_age_by_lmp_days,
          mother_pog : gestational_age_by_lmp_weeks,
          edd_by_lmp : moment(edd_by_lmp).format("YYYY-MM-DD"),
        });
        await this.obsGyaneFormRef.current.setFieldsValue({
          mother_pog: gestational_age_by_lmp_weeks,
          gestational_age_by_lmp_weeks: gestational_age_by_lmp_weeks,
          gestational_age_by_lmp_days: gestational_age_by_lmp_days,
          edd_by_lmp : moment(edd_by_lmp),
        });
      }
      else
      {
        await this.setState({
          mother_pog : null,
          no_of_fetus : null,
          corrected_edd : null,
          edd_by_lmp : null,
          confirmed_by : [],
          gestational_age_by_lmp_weeks : null,
          gestational_age_by_lmp_days : null,
          gestational_age_by_usg_days : null,
          gestational_age_by_usg_weeks : null,
          mother_pog : null,
          mother_weight : null,
          mother_blood_pressure : null,
          mother_pulse_rate : null,
          mother_fundal_height : null,
          mother_edema : null,
          mother_pallor : null,
          mother_cervix_exam : null,
          mother_preterm_labour : null,
          mother_fetal_parameters : [],
          mother_remarks : null,
          mother_fetal_print_with_prescription : '0'
        });
        await this.obsGyaneFormRef.current.setFieldsValue({
          mother_pog : null,
          no_of_fetus : null,
          corrected_edd : null,
          edd_by_lmp : null,
          gestational_age_by_lmp_weeks : null,
          gestational_age_by_lmp_days : null,
          gestational_age_by_usg_days : null,
          gestational_age_by_usg_weeks : null,
          mother_pog : null,
          mother_weight : null,
          mother_blood_pressure : null,
          mother_pulse_rate : null,
          mother_fundal_height : null,
          mother_edema : null,
          mother_pallor : null,
          mother_cervix_exam : null,
          mother_preterm_labour : null,
          mother_remarks : null,
          mother_fetal_print_with_prescription : '0'
        });
      }
    });

    await this.obsGyaneFormRef.current.setFieldsValue({
      pregnant : value
    });

    // Pregnancy status affects the Gravida minimum (+1 when pregnant), so re-check the
    // obstetric fields whenever it toggles.
    this.obsGyaneFormRef.current.validateFields(this.moduleFields.obstetric).catch(() => {});
  }

  onChangePreviousComplicationCheck = async (event) => {
    
    await this.setState({
      any_previous_complications: event.target.value,
      obs_gyane_change_detected: true
    });

    await this.obsGyaneFormRef.current.setFieldsValue({
      any_previous_complications : event.target.value
    });
  }

  handleOnPregnancyRiskFactorChange = async (val,props) => {
    // console.log(val);
    // console.log(props);
    let pregnancy_risk_factor_selected_data = [];
    await this.setState({
      pregnancy_risk_factor_selected: val,
      obs_gyane_change_detected : true
    });
    props.forEach(element => {
      pregnancy_risk_factor_selected_data.push(element.value);
    });

    await this.setState({
      pregnancy_risk_factor: pregnancy_risk_factor_selected_data.join(),
      obs_gyane_change_detected: true
    });
  }

  disabledLmpDate(current) {
    const today = moment().endOf('day');
    const tenMonthsAgo = moment().subtract(10, 'months').startOf('day');
    return current && (current > today || current < tenMonthsAgo);
    // return current && current > moment();
  }

  disableEDDDate = (current) => {
    const eddByLMP = moment(this.state.edd_by_lmp, "YYYY-MM-DD");
    const minDate = moment(eddByLMP).subtract(4, 'weeks');
    const maxDate = moment(eddByLMP).add(4, 'weeks');
    return current && (current < minDate || current > maxDate)
  }

  disableCorrectedEDDDate = (current) => {
    const eddByLMP = moment(this.state.edd_by_lmp, "YYYY-MM-DD");
    const minDate = moment(eddByLMP).subtract(4, 'weeks');
    const maxDate = moment(eddByLMP).add(4, 'weeks');
    return current && (current < minDate || current > maxDate)
  };

  handleEDDChange = async (date, dateString, field) => {
    await this.setState({
      edd_by_lmp: moment(date).format("YYYY-MM-DD"),
      obs_gyane_change_detected : true,
    })

    await this.obsGyaneFormRef.current.setFieldsValue({
      edd_by_lmp : moment(date)
    });
  };

  handleCorrectedEDDChange = async (date, dateString, field) => {
    // Gestational age by USG is derived from the Corrected EDD:
    // GA today = 280 days (40 weeks) minus the days remaining until the corrected EDD.
    const { weeks: usgWeeks, days: usgDays } = this.getGestationalAgeFromEdd(date);

    await this.setState({
      corrected_edd: moment(date).format("YYYY-MM-DD"),
      gestational_age_by_usg_weeks: usgWeeks,
      gestational_age_by_usg_days: usgDays,
      obs_gyane_change_detected : true
    })

    await this.obsGyaneFormRef.current.setFieldsValue({
      corrected_edd : moment(date),
      gestational_age_by_usg_weeks: usgWeeks,
      gestational_age_by_usg_days: usgDays,
    });
  };

  // Computes gestational age (weeks/days) today from an EDD (corrected EDD for USG GA).
  // GA today = 280 - (days from today until the EDD). Returns { weeks, days }.
  getGestationalAgeFromEdd = (edd) => {
    if (!edd || !moment(edd).isValid()) {
      return { weeks: null, days: null };
    }
    // DATE-ONLY diff so a time/timezone component on the EDD can't shift the day count.
    const daysToEdd = moment(moment(edd).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days');
    let totalDays = 280 - daysToEdd;
    if (totalDays < 0 || isNaN(totalDays)) {
      return { weeks: 0, days: 0 };
    }
    const weeks = Math.floor(totalDays / 7);
    const days = totalDays % 7;
    return { weeks, days };
  };

  navigateCorrectedEddDate = () => {
    const eddByLMP = moment(this.state.edd_by_lmp, "YYYY-MM-DD");
    if(moment(eddByLMP) == "Invalid date"){
      return moment()
    }
    else{
      return moment(eddByLMP)
    }
  }

  handleFetalParamsChange = async (event, field, index) => {
    event.persist();
    await this.setState(prevState => {
      const prevItems = [...prevState.mother_fetal_parameters];
      prevItems[index][field] = event.target?.value;
      return { mother_fetal_parameters: prevItems };
    });
    await this.setState({
      mother_fetus_change_detected: true
    })
  }

  handleFetalParamsSelectChange = async (value, props, field, index) => {
    await this.setState(prevState => {
      const prevItems = [...prevState.mother_fetal_parameters];
      prevItems[index][field] = value;
      return { mother_fetal_parameters: prevItems };
    });
    await this.setState({
      mother_fetus_change_detected: true
    })
  }

  handleContraceptivesChange = async (e, val) => {
    try {
      let contraceptives_selected_data = [];
      if (val === '1') { // If 'None' checkbox is selected
          contraceptives_selected_data = e.target.checked ? [val] : [];
      } else {
          contraceptives_selected_data = Array.isArray(this.state.contraceptives)
              ? [...this.state.contraceptives]
              : [];
          if (e.target.checked) {
              contraceptives_selected_data.push(val);
          } else {
              contraceptives_selected_data = contraceptives_selected_data.filter(item => item !== val);
          }
          // If 'None' was previously selected, unselect it
          contraceptives_selected_data = contraceptives_selected_data.filter(item => item !== '1');
      }

      await this.setState({ contraceptives : contraceptives_selected_data , sexual_change_detected : true });
    } catch (error) {
        console.error("Error occurred in handleContraceptivesChange:", error);
    }
  }

  handleConfirmedByChange = async (e, val) => {
    let updatedConfirmedDone = [...this.state.confirmed_by];
    if (e.target.checked) {
      updatedConfirmedDone.push(val);
    } else {
      // If checkbox is unchecked, remove the value from the array
      updatedConfirmedDone = updatedConfirmedDone.filter(item => item != val);
    }
    // Update the state with the new confirmed_by array
    await this.setState({ confirmed_by: updatedConfirmedDone, obs_gyane_change_detected: true });
  }

  handleComplicationDetailsChange = async (e, val) => {
    let updatedComplicationDetails = [...this.state.any_previous_complication_details];
    if (e.target.checked) {
      updatedComplicationDetails.push(val);
    } else {
      // If checkbox is unchecked, remove the value from the array
      updatedComplicationDetails = updatedComplicationDetails.filter(item => item != val);
    }
    // Update the state with the new any_previous_complication_details array
    await this.setState({ any_previous_complication_details: updatedComplicationDetails, obs_gyane_change_detected: true });

    // console.log(this.state.any_previous_complication_details);
  }

  autoHeight = (e) => {
    if(e)
    {
      e.target.style.height = e.target.scrollHeight + "px";
    }
  }

  optionRiskFactorsList() {
    return Axios.get(RISK_FACTORS_LIST).then(async success => {
      if (success?.data?.status == true) {
          this.setState({ risk_factors_list: success.data.data });
      }
    }).catch(err => console.log(err));
  }

  handleFetusChange = async (no_of_fetus) => {
    var new_length = no_of_fetus;
    if(no_of_fetus > 0)
    {
      let prev_length = this.state.mother_fetal_parameters.length;
      if (new_length > prev_length) {
        let adds = new_length - prev_length;
        for (let i = 0; i < adds; i++) {
          await this.setState(prevState => {
            // fetus_no = 1-based position of the appended row.
            const obj = { fetus_no: prevState.mother_fetal_parameters.length + 1, fetal_movement: null, fetal_heart_rate: null, presentation: null, relationship_of_pp_to_brim: null, head_cc: null, abdominal_cc: null, femur_length: null }
            const newItems = [...prevState.mother_fetal_parameters, obj];
            return { mother_fetal_parameters: newItems };
          });
        }
      } else if (prev_length > new_length) {
        let removes = prev_length - new_length;
        let index = prev_length - 1;
        for (let i = 0; i < removes; i++) {
          let prevValues = await this.obsGyaneFormRef.current.getFieldsValue();
          await this.setState(prevState => ({
            mother_fetal_parameters: prevState.mother_fetal_parameters.filter((data, j) => j !== index)
          }));
          // await prevValues['blood_bag_master'].splice(index, 1);
          await this.obsGyaneFormRef.current.setFieldsValue({
            ...prevValues
          })
          index--;
        }
      }
    }
    await this.setState({
      no_of_fetus: no_of_fetus,
      obs_gyane_change_detected : true,
      mother_fetus_change_detected : true
    })
  }

  optionRiskFactorsLoad() {
    if (!this.state.risk_factors_list || this.state.risk_factors_list.length === 0) {
      return (<Option value={0}><span>No Result Found</span></Option>)
    }
    return this.state.risk_factors_list.map((obj, i) => {
      return (<Option key={i} value={parseInt(obj.id)} title={obj.description}>{obj.description}</Option>)
    }, this)
  }

  initSpeech = async (info) => {
    let initialText = '';
    if (info.identifier === 'menstrual_remarks') {
      initialText = this.state.menstrual_remarks != undefined ? this.state.menstrual_remarks : '';
    }
    if (info.identifier === 'married_life') {
      initialText = this.state.married_life != undefined ? this.state.married_life : '';
    }
    if (info.identifier === 'contraceptive_remarks') {
      initialText = this.state.contraceptive_remarks != undefined ? this.state.contraceptive_remarks : '';
    }
    if (info.identifier === 'remarks') {
      initialText = this.state.remarks != undefined ? this.state.remarks : '';
    }
    if (info.identifier === 'pregnancy_risk_factor_management_remarks') {
      initialText = this.state.pregnancy_risk_factor_management_remarks != undefined ? this.state.pregnancy_risk_factor_management_remarks : '';
    }
    if (info.identifier === 'obstetric_remarks') {
      initialText = this.state.obstetric_remarks != undefined ? this.state.obstetric_remarks : '';
    }
    if (info.identifier === 'mother_remarks') {
      initialText = this.state.mother_remarks != undefined ? this.state.mother_remarks : '';
    }

    if (info.identifier === this.state.speech.identifier) {
      this.setState({
          speech: {
              identifier: info.identifier,
              state: !this.state.speech.state,
              initialText: initialText
          }
      }, () => {
          speechService.init(this.state.speech);
      });
    }
    else {
      this.setState({
        speech: {
          identifier: this.state.speech.identifier,
          state: false,
          initialText: ''
        }
      }, () => {
        speechService.init(this.state.speech);
        setTimeout(() => {
          this.setState({
            speech: {
              identifier: info.identifier,
              state: true,
              initialText: initialText
            }
          }, () => {
            speechService.init(this.state.speech);
          });
        }, 1000);
      });
    }
  }

	render() {
    const { ss_configuration, consult_type, sinceByList, contraceptives, confirmed_by, any_previous_complication_details, mother_fetal_parameters } = this.state;
    const textareaSizeDefault = { minRows: 3, maxRows: 6 };
    // Resolve each configuration-driven visibility flag once per render instead of
    // re-scanning ss_configuration inline for every section.
    const show21 = this.isSubItemSelected(21);
    const show22 = this.isSubItemSelected(22);
    const show25 = this.isSubItemSelected(25);
    const show26 = this.isSubItemSelected(26);
    const show28 = this.isSubItemSelected(28);
    const show29 = this.isSubItemSelected(29);
    const show30 = this.isSubItemSelected(30);
    const show32 = this.isSubItemSelected(32);
    const show33 = this.isSubItemSelected(33);
    const show34 = this.isSubItemSelected(34);
		return (
      <Fragment>
        <MyHcSpeechRecognition />
				<div className="card-body  gynae_body p-1 emrfrm">
          <div className='container-fluid medicines  med-cont pb-2'>
            <Form
              layout='vertical'
              className='emrfrm'
              ref={this.obsGyaneFormRef}
            >
              {
                (show21 || show22)
                ?
                  <div className='row d-flex align-items-center mb-4'>
                    <div className='col-auto pr-3'>
                        <h6 className='text-primary mb-0'>Menstrual History</h6>
                    </div>
                    <div className='col-2'>
                      <div className='antInputItem hasdata'>
                        <Form.Item
                          label="Menarch Age"
                          name="menarch_age"
                          rules={[{
                            type: 'number',
                            min: 7,
                            max: this.state.patient_dob,
                            message:"Duration of period cannot be less than 7 or greater than patient age",
                            transform: function (value) {
                            return (value === "" || value === undefined || value === null) ? undefined : +value
                           }
                        }]}
                        >
                          <Input
                            addonAfter="Years"
                            maxLength="2"
                            name="menarch_age"
                            className="onlynumbers"
                            value={this.state.menarch_age}
                            disabled={!this.state.allowEdit}
                            onChange={this.handleOnNumberChange}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='col-2'>
                      <div className={`antInputItem hasdata`} style={{}}>
                        <Form.Item
                          label="Regularity"
                          name="regularity"

                        >
                          <Select
                            name="regularity"
                            onChange={(val, props) => this.onSelectChange(val, props, 'regularity')} 
                            value={this.state.regularity}
                            disabled={!this.state.allowEdit}
                          >
                            <Option value="regular">
                                Regular
                            </Option>
                            <Option value="irregular">
                                Irregular
                            </Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className='col-2'>
                      <div className={`antInputItem hasdata`} style={{}}>
                        <Form.Item
                          label="Flow"
                          name="flow"
                        >
                          <Select
                            name="flow"
                            onChange={(val, props) => this.onSelectChange(val, props, 'flow')}
                            value={this.state.flow}
                            disabled={!this.state.allowEdit}
                          >
                            <Option value="normal_flow">
                                Normal flow
                            </Option>
                            <Option value="light_flow">
                                Light flow
                            </Option>
                            <Option value="heavy_flow">
                                Heavy flow
                            </Option>
                            <Option value="irregular_flow">
                                Irregular flow
                            </Option>
                            <Option value="no_bleeding">
                                No bleeding
                            </Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                :
                null
              }

              <div className='row d-flex align-items-center mb-4'>
                {
                  show22
                  ?
                    <div className='col-2'>
                      <div className='antInputItem hasdata'>
                        <Form.Item
                          name="lmp"
                          className='mb-0'
                          label="LMP"
                        >
                          <DatePicker
                            name="lmp"
                            format="DD MMM, YYYY"
                            className='mb-0'
                            style={{
                                width: "100%",
                                height: "34px",
                            }}
                            allowClear={false}
                            onChange={(date, dateString) => this.handleLmpDateChange(date, dateString, 'lmp')}
                            disabledDate={this.disabledLmpDate}
                            disabled={!this.state.allowEdit || this.state.pregnant === "1"}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  : 
                  null
                }
                {
                  /* LMP actions: edit-icon (hover "Edit LMP", pregnant + editable only) and the
                     audit view-log icon (always shown when audit data exists). Kept in its own
                     col-1 right after LMP so the row layout stays clean. */
                  (show22 && ((this.state.allowEdit && this.state.pregnant === "1") || this.state.lmpAuditData?.length > 0))
                  ?
                    <div className='col-1 d-flex align-items-center' style={{ marginTop: '18px' }}>
                      {
                        (this.state.allowEdit && this.state.pregnant === "1")
                        ?
                          <Tooltip placement="top" title="Edit LMP">
                            <a href="javascript:void(0);" className="nostyle-link mr-2" onClick={this.openLmpEdit}><i className="icon-edit" /></a>
                          </Tooltip>
                        :
                        null
                      }
                      {
                        this.state.lmpAuditData?.length > 0
                        ?
                          <Tooltip placement="top" title="View LMP Change Log">
                            <a href="javascript:void(0);" className="text-danger" onClick={() => this.setState({ lmpAuditModalVisible: true })}><i className="icon_view" /></a>
                          </Tooltip>
                        :
                        null
                      }
                    </div>
                  :
                  null
                }
                <div className='col-2'>
                  <div className={`antInputItem hasdata`} style={{}}>
                    <Form.Item
                      name="bleeding_days"
                      label="Bleeding Days"
                      rules={[{
                          type: 'number',
                          min: 1,
                          max: 99,
                          message:"Duration of period cannot be less than 1 or greater than 99",
                          transform: function (value) {
                          return (value === "" || value === undefined || value === null) ? undefined : +value
                         }
                      }]}
                    >
                      <Input
                        type="text"
                        name="bleeding_days"
                        id="bleeding_days"
                        className="onlynumbers"
                        maxLength="2"
                        value={this.state.bleeding_days}
                        disabled={!this.state.allowEdit}
                        onChange={this.handleOnNumberChange}
                      />
                    </Form.Item>
                  </div>
                </div>
               { 
                  show21
                  ? 
                    <div className='col-2'>
                      <div className='antInputItem hasdata'>
                        <Form.Item name={'cycle_length'} label={'Cycle Length (Days)'} rules={[{
                          type: 'number',
                          min: 10,
                          max: 99,
                          message: "Cycle length cannot be less than 10 or greater than 99.",
                          transform: function (value) {
                              return (value === "" || value === undefined || value === null) ? undefined : +value
                          }
                        }]} >
                          <Input
                              id={'cycle_length'}
                              name={'cycle_length'}
                              autoComplete="off"
                              maxlength="2"
                              value={this.state.cycle_length}
                              disabled={!this.state.allowEdit}
                              onChange={this.handleOnNumberChange}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  : 
                  null
                }
                <div className='col'>
                  <div className='antInputItem micwrap ant-mic-wrap hasdata'>
                    <Link
                      onClick={(e) => {
                          e.preventDefault(); this.initSpeech({ identifier: "menstrual_remarks" });
                      }}
                      className={
                        this.state.speech.identifier === "menstrual_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                      }
                    ></Link>
                    <Form.Item
                      label="Menstrual Remarks"
                      name="menstrual_remarks"
                    >
                       <TextArea
                        id="menstrual_remarks"
                        name="menstrual_remarks"
                        style={{ overflow: "hidden" }}
                        oninput="auto_height(this)"
                        onInput={(e) => this.autoHeight(e)}
                        placeholder='Menstrual Remarks'
                        autoComplete="off"
                        onChange={this.handleOnTextChange}
                        disabled={!this.state.allowEdit}
                        value={this.state.menstrual_remarks}
                      >
                      </TextArea>
                    </Form.Item>
                  </div>
                </div>
              </div>
              <hr className='my-3' />
              <div className='row d-flex justify-content-between align-items-center'>
                <div className='col-10'>
                  {/* Section header: kept clearly larger than the sub-field labels
                      (Sexually Active / Marital Status) below it. */}
                  <h6 className='text-primary mb-0' style={{ fontSize: '15px', fontWeight: 600 }}>Sexual History</h6>
                </div>
                <div className='col-auto'>
                  <Checkbox
                    name="sexual_history_data_confidential"
                    disabled={!this.state.allowEdit}
                    checked={this.state.sexual_history_data_confidential === '1'}
                    onChange={e => this.handleSexualDataConfidentialChange(e)}
                  >
                    <span className='text-secondary font-weight-bold'>Confidential</span>
                  </Checkbox>
                </div>
              </div>
              <div className="row mt-2 align-items-center">
                <div className="col-1" style={{ width: '130px' }}>
                  {/* Sub-field label: smaller than the "Sexual History" section header above. */}
                  <span className="pt-0 d-block font-cus" style={{ fontSize: '13px' }}>
                    Sexually Active 
                  </span>
                </div>
                <div className="col-2">
                  <div className="custom-control custom-radio custom-control-inline" style={{ width: '90px' }}>
                    <input
                      type="radio"
                      id="yes-sexually"
                      name="sexually_active"
                      className="custom-control-input"
                      disabled={!this.state.allowEdit}
                      value="1"
                      checked={this.state.sexually_active==='1'}
                      onChange={(e) => this.onChangeRadioCheck(e)}
                    />
                    <label
                      className="custom-control-label pl-2"
                      htmlFor="yes-sexually"
                      style={{ fontSize: '13px' }}
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="no-sexually"
                      name="sexually_active"
                      className="custom-control-input"
                      disabled={!this.state.allowEdit}
                      value="0"
                      checked={this.state.sexually_active==='0'}
                      onChange={(e) => this.onChangeRadioCheck(e)}
                    />
                    <label
                      className="custom-control-label pl-2"
                      htmlFor="no-sexually"
                      style={{ fontSize: '13px' }}
                    >
                      No
                    </label>
                  </div>
                </div>
                <div className="col-3">
                  <div className={this.state.since ? 'form-label-group input-group hasdata' : 'form-label-group input-group'} >
                    <input
                      type="text"
                      className="form-control onlynumbers"
                      id="since-sexual"
                      placeholder="Since"
                      maxLength="5"
                      name="since"
                      style={{ height: "calc(2rem + 2px)" }}
                      onChange={this.handleOnNumberChange}
                      disabled={!this.state.allowEdit || this.state.sexually_active !== '1'}
                      value={this.state.since ?? ''}
                    />
                    <span className="input-group-addon max-120" style={{ padding: "0px", height: "calc(2rem + 2px)" }}>
                      <select className="custom-select" name="since_by" value={this.state.since_by} onChange={this.onSelectSinceByChange} disabled={!this.state.allowEdit || this.state.sexually_active !== '1'} style={{ height: "calc(2rem + 2px)" }}>
                          {sinceByList !== undefined && sinceByList.length > 0 ? sinceByList.map(d => (
                            <option key={d.id} value={d.id} label={d.desc}>{d.desc}</option>
                          )) : null}
                      </select>
                    </span>
                    <label
                      htmlFor="since-sexual"
                      className="pt-0"
                    >
                      Since
                    </label>
                  </div>
                </div>
              </div>
              <div className="row mt-3 align-items-center">
                <div className="col-1" style={{ width: '130px' }}>
                  {/* Sub-field label: smaller than the "Sexual History" section header above. */}
                  <span className="pt-0 d-block font-cus" style={{ fontSize: '13px' }}>
                    Marital Status
                  </span>
                </div>
                <div className="col-2">
                  <div className="custom-control custom-radio custom-control-inline" style={{ width: '90px' }}>
                    <input
                      type="radio"
                      id="single-marital"
                      name="marital_status"
                      className="custom-control-input"
                      disabled={!this.state.allowEdit}
                      value="1"
                      checked={this.state.marital_status === '1'}
                      onChange={(e) => this.onChangeMaritalStatus(e)}
                    />
                    <label
                      className="custom-control-label pl-2"
                      htmlFor="single-marital"
                      style={{ fontSize: '13px' }}
                    >
                      Single
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="married-marital"
                      name="marital_status"
                      className="custom-control-input"
                      disabled={!this.state.allowEdit}
                      value="2"
                      checked={this.state.marital_status === '2'}
                      onChange={(e) => this.onChangeMaritalStatus(e)}
                    />
                    <label
                      className="custom-control-label pl-2"
                      htmlFor="married-marital"
                      style={{ fontSize: '13px' }}
                    >
                      Married
                    </label>
                  </div>
                </div>
                {
                  this.state.marital_status === '2'
                  ?
                    <>
                      <div className='col-3'>
                        <div className={`antInputItem hasdata`} style={{}}>
                          <Form.Item
                            name="spouse_name"
                            label="Spouse Name"
                          >
                            <Input
                              id="spouse_name"
                              name="spouse_name"
                              maxLength="150"
                              autoComplete="off"
                              disabled={!this.state.allowEdit}
                              onChange={this.handleOnTextChange}
                              value={this.state.spouse_name}
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <div className='col-6'>
                        <div className={`antInputItem micwrap ant-mic-wrap hasdata`}>
                          <Link
                            onClick={(e) => {
                                e.preventDefault(); this.initSpeech({ identifier: "married_life" });
                            }}
                            className={
                              this.state.speech.identifier === "married_life" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                            }
                          ></Link>
                          <Form.Item
                            label="Married Life"
                            name="married_life"
                          >
                            <Input.TextArea
                              id="married_life"
                              name="married_life"
                              disabled={!this.state.allowEdit}
                              style={{ overflow: "hidden" }}
                              oninput="auto_height(this)"
                              onInput={(e) => this.autoHeight(e)}
                              onChange={this.handleOnTextChange}
                              value={this.state.married_life}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </>
                  :
                  null
                }
              </div>
              <div className="row my-4">
                <div className="col-auto d-flex align-items-center pr-3">
                  Contraceptives
                </div>
                <div className='row d-flex align-items-center'>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="none"
                      checked={contraceptives?.includes('1')}
                      disabled={!this.state.allowEdit}
                      onChange={e => this.handleContraceptivesChange(e, '1')}  
                    >
                      None
                    </Checkbox>
                  </div>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="condom"
                      checked={contraceptives?.includes('2')}
                      onChange={e => this.handleContraceptivesChange(e, '2')}
                      disabled={contraceptives?.includes('1') || !this.state.allowEdit}
                    >
                      Condom
                    </Checkbox>
                  </div>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="iud"
                      checked={contraceptives?.includes('3')}
                      onChange={e => this.handleContraceptivesChange(e, '3')}
                      disabled={contraceptives?.includes('1') || !this.state.allowEdit}
                    >
                      IUD
                    </Checkbox>
                  </div>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="ocp"
                      checked={contraceptives?.includes('4')}
                      onChange={e => this.handleContraceptivesChange(e, '4')}
                      disabled={contraceptives?.includes('1') || !this.state.allowEdit}
                    >
                      OCP
                    </Checkbox>
                  </div>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="hormonal"
                      checked={contraceptives?.includes('5')}
                      onChange={e => this.handleContraceptivesChange(e, '5')}
                      disabled={contraceptives?.includes('1') || !this.state.allowEdit}
                    >
                      Hormonal
                    </Checkbox>
                  </div>
                </div>
                <div className='col'>
                  <div className={this.state.contraceptive_remarks ? 'form-group micwrap ant-mic-wrap hasdata mb-0' : 'form-group micwrap ant-mic-wrap mb-0'}>
                    <Link
                      onClick={(e) => {
                          e.preventDefault(); this.initSpeech({ identifier: "contraceptive_remarks" });
                      }}
                      className={
                        this.state.speech.identifier === "contraceptive_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                      }
                    ></Link>
                    <Input.TextArea
                      className="form-control speech-field"
                      rows="1"
                      placeholder="Contraceptive Remarks"
                      disabled={!this.state.allowEdit}
                      id="contraceptive_remarks"
                      // maxlegth="255"
                      oninput="auto_height(this)"
                      onInput={(e) => this.autoHeight(e)}
                      name="contraceptive_remarks"
                      onChange={this.handleOnTextChange}
                      value={this.state.contraceptive_remarks}
                    />
                    <label htmlFor="contraceptive_remarks">
                        Contraceptive Remarks
                    </label>
                  </div>
                </div>
              </div>
              {
                show34
                ?
                  <div className='row d-flex align-items-center'>
                    <div className='col'>
                      <div className={this.state.remarks ? 'form-group micwrap ant-mic-wrap hasdata mb-0' : 'form-group micwrap ant-mic-wrap mb-0'}>
                        <Link
                          onClick={(e) => {
                              e.preventDefault(); this.initSpeech({ identifier: "remarks" });
                          }}
                          className={
                            this.state.speech.identifier === "remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                          }
                        ></Link>
                        <Input.TextArea
                          className="form-control speech-field"
                          rows="1"
                          placeholder="Remarks"
                          disabled={!this.state.allowEdit}
                          id="remarks"
                          oninput="auto_height(this)"
                          onInput={(e) => this.autoHeight(e)}
                          name="remarks"
                          onChange={this.handleOnTextChange}
                          value={this.state.remarks}
                        />
                        <label htmlFor="remarks">Remarks</label>
                      </div>
                    </div>
                    {/*
                      <div className='col-auto mb-4 text-right '>
                        <Checkbox
                          name="remarks_confidential"
                          checked={this.state.remarks_confidential === '1'}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleSexualRemarksConfidentialChange(e)}
                        >
                          <span className='text-secondary font-weight-bold'>Confidential</span>
                        </Checkbox>
                      </div>
                    */}
                  </div>
                :
                null
              }
              {
                (show25 || show26)
                ?
                  <>
                  <hr className='my-3' />
                  {/* Lactating and Pregnant laid out like Sexually Active / Marital Status:
                      two separate rows, each a fixed-width label + an inline radio group.
                      EDD / audit fields (shown only when pregnant) follow in their own row. */}
                  {
                    show25
                    ?
                      <div className="row mt-2 align-items-center">
                        <div className="col-1" style={{ width: '130px' }}>
                          <span className="pt-0 d-block font-cus" style={{ fontSize: '13px' }}>
                            Lactating
                          </span>
                        </div>
                        <div className="col-auto">
                          <Form.Item name="lactating" className='mb-0'>
                            <Radio.Group name='lactating' value={this.state.lactating} onChange={(e) => this.handleLactatingChange(e)} disabled={!this.state.allowEdit}>
                              <Radio value="0" name="lactating_no">No</Radio>
                              <Radio value="1" name="lactating_yes">Yes</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </div>
                      </div>
                    :
                    null
                  }
                  {
                    show26
                    ?
                      <div className="row mt-3 align-items-center">
                        <div className="col-1" style={{ width: '130px' }}>
                          <span className="pt-0 d-block font-cus" style={{ fontSize: '13px' }}>
                            Pregnant
                          </span>
                        </div>
                        <div className="col-auto d-flex align-items-center">
                          <Form.Item name="pregnant" className='mb-0'>
                            <Radio.Group name='pregnant' defaultValue={this.state.pregnant} onChange={(e) => this.onChangePregnantCheck(e)} disabled={!this.state.allowEdit || this.state.pregnant === "1"}>
                              <Radio value="0" name="no">No</Radio>
                              <Radio value="1" name="yes">Yes</Radio>
                            </Radio.Group>
                          </Form.Item>
                          {
                            (this.state.pregnant === "1" && this.state.pregnantAuditData?.length > 0)
                            ?
                              <Tooltip placement="top" title="View Log">
                                <a href="javascript:void(0);" className="text-danger ml-2" onClick={() => this.setState({ pregnantAuditModalVisible: true })}><i className="icon_view" /></a>
                              </Tooltip>
                            :
                            null
                          }
                        </div>
                      </div>
                    :
                      null
                  }
                  {
                    (show26 && this.state.pregnant === "1")
                    ?
                      <div className='row d-flex align-items-center mt-2'>
                        <div className='col-3'>
                          <div className='antInputItem hasdata'>
                            <Form.Item
                              name="edd_by_lmp"
                              className='mb-0'
                              label="EDD By LMP"
                            >
                              <DatePicker
                                name="edd_by_lmp"
                                format="DD MMM, YYYY"
                                className='mb-0'
                                style={{
                                    width: "100%",
                                    height: "34px",
                                }}
                                allowClear={false}
                                defaultValue={this.state.edd_by_lmp}
                                disabled={!this.state.allowEdit || this.state.pregnant === "1"}
                                value={this.state.edd_by_lmp}
                                onChange={(date, dateString) => this.handleEDDChange(date, dateString, 'edd_by_lmp')}
                                disabledDate={this.disableEDDDate}
                              />
                            </Form.Item>
                          </div>
                        </div>
                        <div className='col-3'>
                          <div className='antInputItem hasdata'>
                            <Form.Item
                              name="corrected_edd"
                              className='mb-0'
                              label="Corrected EDD"
                            >
                              <DatePicker
                                name="corrected_edd"
                                format="DD MMM, YYYY"
                                className='mb-0'
                                style={{
                                    width: "100%",
                                    height: "34px",
                                }}
                                allowClear={false}
                                defaultValue={this.state.corrected_edd}
                                disabled={!this.state.allowEdit}
                                value={this.state.corrected_edd}
                                defaultPickerValue={this.navigateCorrectedEddDate}
                                onChange={(date, dateString) => this.handleCorrectedEDDChange(date, dateString, 'corrected_edd')}
                                disabledDate={this.disableCorrectedEDDDate}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    :
                    null
                  }
                  </>
                : 
                null
              }
              {
                (this.state.pregnant == "1" && show26)
                ?
                  <div className='row mt-3 d-flex align-items-center'>
                    <div className='col-auto pr-4'>
                      <h6 className='text-primary mb-0 pt-1'>Confirmed by</h6>
                    </div>
                    <div className='col-auto pr-3'>
                        <Checkbox
                          name="upt"
                          checked={confirmed_by?.includes('1')}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleConfirmedByChange(e, '1')}   
                        >
                          UPT
                        </Checkbox>
                    </div>
                    <div className='col-auto pr-3'>
                        <Checkbox
                          name="serumhcg"
                          checked={confirmed_by?.includes('2')}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleConfirmedByChange(e, '2')}   
                        >
                          Serum HCG
                        </Checkbox>
                    </div>
                    <div className='col-auto pr-3'>
                        <Checkbox
                          name="usg"
                          checked={confirmed_by?.includes('3')}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleConfirmedByChange(e, '3')}   
                        >
                          USG
                        </Checkbox>
                    </div>
                    <div className='col-auto'>
                        <Checkbox
                          name="home"
                          checked={confirmed_by?.includes('4')}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleConfirmedByChange(e, '4')}   
                        >
                          Home Pregnancy Test
                        </Checkbox>
                    </div>
                  </div>
                :
                null
              }
              {
                (show26 || show30)
                ?
                  <div className='row d-flex align-items-center mb-4'>
                    {
                      (this.state.pregnant == "1" && show26) 
                      ?
                        <div className='col-6'>
                          <div className='row d-flex align-items-center'>
                            <div className='col-12'>
                              <h6 className='text-primary' >Gestational Age</h6>
                            </div>
                          </div>
                          <div className='row mt-3'>
                              <div className='col-auto' >
                                <label>By LMP</label>
                              </div>
                              <div className='col-2'>
                                <div className='antInputItem hasdata'>
                                  <Form.Item
                                    label="Weeks"
                                    name="gestational_age_by_lmp_weeks"
                                  >
                                    <Input
                                      id="weeks"
                                      name="gestational_age_by_lmp_weeks"
                                      disabled={!this.state.allowEdit || this.state.pregnant === "1"}
                                      maxlength="2"
                                      onChange={this.handleOnNumberChange}
                                      value={this.state.gestational_age_by_lmp_weeks}
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='col-2'>
                                <div className='antInputItem hasdata'>
                                  <Form.Item
                                    label="Days"
                                    name="gestational_age_by_lmp_days"
                                    rules={[
                                      { pattern: /^(0?)([1-6]{0,1})$/, message: 'Not allowed!' }
                                    ]}
                                  >
                                    <Input
                                      id="days"
                                      name="gestational_age_by_lmp_days"
                                      disabled={!this.state.allowEdit || this.state.pregnant === "1"}
                                      maxlength="1"
                                      onChange={this.handleOnNumberChange}
                                      value={this.state.gestational_age_by_lmp_days}
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='col-auto pl-4' >
                                <label>By USG</label>
                              </div>
                              <div className='col-2'>
                                <div className='antInputItem hasdata'>
                                  <Form.Item
                                    label="Weeks"
                                    name="gestational_age_by_usg_weeks"
                                  >
                                    <Input
                                      id="weeks"
                                      name="gestational_age_by_usg_weeks"
                                      disabled={!this.state.allowEdit}
                                      maxLength="2"
                                      onChange={this.handleOnNumberChange}
                                      value={this.state.gestational_age_by_usg_weeks}
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='col-2'>
                                <div className='antInputItem hasdata'>
                                  <Form.Item
                                    label="Days"
                                    name="gestational_age_by_usg_days"
                                    rules={[
                                      { pattern: /^(0?)([1-6]{0,1})$/, message: 'Not allowed!' }
                                      ]}
                                  >
                                    <Input
                                      id="days"
                                      name="gestational_age_by_usg_days"
                                      disabled={!this.state.allowEdit}
                                      maxLength="1"
                                      onChange={this.handleOnNumberChange}
                                      value={this.state.gestational_age_by_usg_days}
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                          </div>
                        </div>
                      :
                      null
                    }

                    {
                      show30
                      ?
                        <div className="col-6">
                          <div className='row '>
                            <div className='col-4'>
                              <h6 className='text-primary mb-0'>Obstetric History</h6>
                            </div>
                            <div className='col-4 text-center'>
                              <a className='text-secondary font-weight-bold' style={{ cursor: 'pointer' }} onClick={() => { this.setState({ previousPregnancyDetailsModal: true }) }}>
                                <u>+Previous Pregnancy Details</u>
                              </a>
                            </div> 
                            <div className='col-4 text-right'>
                              <Checkbox
                                name="obstetric_data_confidential"
                                disabled={!this.state.allowEdit}
                                checked={this.state.obstetric_data_confidential === '1'}
                                onChange={e => this.handleObsterticDataConfidentialChange(e)}
                              >
                                <span className='text-secondary font-weight-bold'>Confidential</span>
                              </Checkbox>
                            </div>
                          </div>
                          <div className='row mt-2'>
                            <div className="col-12">
                              <div className='card obs-hiscard mb-0'>
                                <div className='row'>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                        <Form.Item
                                          label="Gravidity"
                                          name="gravidity"
                                          rules={[
                                            {
                                              validator: (_, value) => {
                                                if (value === undefined || value === null || value === '') {
                                                  return Promise.resolve();
                                                }
                                                if (!/^\d{1,2}$/.test(value)) {
                                                  return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                                }
                                                // Gravida = Parity + Abortion (+ current pregnancy)
                                                const { parity, abortion, isPregnant } = this.getObstetricValues();
                                                const gravidity = parseInt(value);
                                                let minGravida = 0;
                                                if (!isNaN(parity)) minGravida += parity;
                                                if (!isNaN(abortion)) minGravida += abortion;
                                                if (isPregnant) minGravida += 1;
                                                if (gravidity < minGravida) {
                                                  return Promise.reject(
                                                    new Error('Gravida must be at least Parity + Abortion' + (isPregnant ? ' + current pregnancy' : ''))
                                                  );
                                                }
                                                return Promise.resolve();
                                              }
                                            },
                                          ]}
                                        >
                                          <Input
                                            id="gravidity"
                                            name="gravidity"
                                            disabled={!this.state.allowEdit}
                                            // type="text"
                                            maxLength="2"
                                            onChange={this.handleOnNumberChange}
                                            value={this.state.gravidity}
                                          />
                                        </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Parity"
                                        name="parity"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // Parity = Term + Pre-term + Still Birth
                                              const { term, preterm, still_birth } = this.getObstetricValues();
                                              const parity = parseInt(value);
                                              if (!isNaN(term) && !isNaN(preterm) && !isNaN(still_birth)) {
                                                if (parity !== (term + preterm + still_birth)) {
                                                  return Promise.reject(new Error('Parity must equal Term + Pre-term + Still Birth'));
                                                }
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="parity"
                                          name="parity"
                                          disabled={!this.state.allowEdit}
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          value={this.state.parity}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-4'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Abortion"
                                        name="abortion"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // Abortion = Miscarriage + MTP + Ectopic
                                              const { miscarriage, mtp, ectopic } = this.getObstetricValues();
                                              const abortion = parseInt(value);
                                              if (!isNaN(miscarriage) && !isNaN(mtp) && !isNaN(ectopic)) {
                                                if (abortion !== (miscarriage + mtp + ectopic)) {
                                                  return Promise.reject(new Error('Abortion must equal Miscarriage + MTP + Ectopic'));
                                                }
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="abortion"
                                          name="abortion"
                                          disabled={!this.state.allowEdit}
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          value={this.state.abortion}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Live Birth"
                                        name="live_birth"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // Live Birth cannot exceed Parity (deliveries after viability)
                                              const { parity } = this.getObstetricValues();
                                              const liveBirth = parseInt(value);
                                              if (!isNaN(parity) && liveBirth > parity) {
                                                return Promise.reject(new Error('Live Birth cannot be more than Parity'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="live_birth"
                                          name="live_birth"
                                          disabled={!this.state.allowEdit}
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          value={this.state.live_birth}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Ectopic"
                                        name="ectopic"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // Ectopic is a component of Abortion
                                              const { abortion } = this.getObstetricValues();
                                              const ectopic = parseInt(value);
                                              if (!isNaN(abortion) && ectopic > abortion) {
                                                return Promise.reject(new Error('Ectopic cannot be more than Abortion'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="ectopic"
                                          name="ectopic"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.ectopic}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                </div>
                                <div className='row mt-3'>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="LSCS"
                                        name="lscs"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // LSCS is a delivery mode, cannot exceed Parity
                                              const { parity } = this.getObstetricValues();
                                              const lscs = parseInt(value);
                                              if (!isNaN(parity) && lscs > parity) {
                                                return Promise.reject(new Error('LSCS cannot be more than Parity'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="lscs"
                                          name="lscs"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.lscs}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Miscarriage"
                                        name="miscarriage"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // Miscarriage is a component of Abortion
                                              const { abortion } = this.getObstetricValues();
                                              const miscarriage = parseInt(value);
                                              if (!isNaN(abortion) && miscarriage > abortion) {
                                                return Promise.reject(new Error('Miscarriage cannot be more than Abortion'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                        >
                                          <Input
                                            id="miscarriage"
                                            name="miscarriage"
                                            // type="text"
                                            maxLength="2"
                                            onChange={this.handleOnNumberChange}
                                            disabled={!this.state.allowEdit}
                                            value={this.state.miscarriage}
                                          />
                                        </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="MTP"
                                        name="mtp"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // MTP is a component of Abortion
                                              const { abortion } = this.getObstetricValues();
                                              const mtp = parseInt(value);
                                              if (!isNaN(abortion) && mtp > abortion) {
                                                return Promise.reject(new Error('MTP cannot be more than Abortion'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="mtp"
                                          name="mtp"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.mtp}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Preterm"
                                        name="preterm"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // Pre-term is a component of Parity
                                              const { parity } = this.getObstetricValues();
                                              const preterm = parseInt(value);
                                              if (!isNaN(parity) && preterm > parity) {
                                                return Promise.reject(new Error('Pre-term cannot be more than Parity'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="preterm"
                                          name="preterm"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.preterm}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Term"
                                        name="term"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // Term is a component of Parity
                                              const { parity } = this.getObstetricValues();
                                              const term = parseInt(value);
                                              if (!isNaN(parity) && term > parity) {
                                                return Promise.reject(new Error('Term cannot be more than Parity'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="term"
                                          name="term"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.term}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Still Birth"
                                        name="still_birth"
                                        rules={[
                                          {
                                            validator: (_, value) => {
                                              if (value === undefined || value === null || value === '') {
                                                return Promise.resolve();
                                              }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                              }
                                              // Still Birth is a component of Parity
                                              const { parity } = this.getObstetricValues();
                                              const stillBirth = parseInt(value);
                                              if (!isNaN(parity) && stillBirth > parity) {
                                                return Promise.reject(new Error('Still Birth cannot be more than Parity'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="still_birth"
                                          name="still_birth"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.still_birth}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      :
                      null
                    }
                  </div>
                :
                null
              }
              {
                (show28 || show29)
                ?
                  <div className='row d-flex align-items-start mb-4'>
                    {
                      show28
                      ?
                        <div className='col-6'>
                          <div className="antSelectItem hasdata mb-0 anc-risk-factor-select">
                            <Form.Item
                              label="Pregnancy risk factors"
                              name="pregnancy_risk_factor"
                              className='mb-0'
                            >
                              <Select
                                showSearch
                                mode="multiple"
                                value={this.state.pregnancy_risk_factor_selected}
                                notFoundContent={null}
                                filterOption={true}
                                disabled={!this.state.allowEdit}
                                onChange={this.handleOnPregnancyRiskFactorChange}
                                style={{ width: '100%', minHeight: '40px' }}
                                optionFilterProp="children"
                              >
                                {this.optionRiskFactorsLoad()}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      :
                      null
                    }
                    {
                      show29
                      ?
                        <div className='col-6'>
                          <div className={`form-group antInputItem micwrap hasdata mb-0`}>
                            <Link
                              onClick={(e) => {
                                  e.preventDefault(); this.initSpeech({ identifier: "pregnancy_risk_factor_management_remarks" });
                              }}
                              className={
                                this.state.speech.identifier === "pregnancy_risk_factor_management_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                              }
                            ></Link>
                            <Form.Item
                              name="pregnancy_risk_factor_management_remarks"
                              className='mb-0'
                            >
                              <Input.TextArea
                                className="form-control diagnosis_notes_class speech-field"
                                id="pregnancy_risk_factor_management_remarks"
                                name="pregnancy_risk_factor_management_remarks"
                                autoSize={{ minRows: 1.3, maxRows: 6 }}
                                maxLength={255}
                                disabled={!this.state.allowEdit}
                                style={{ minHeight: '40px' }}
                                onInput={(e) => this.autoHeight(e)}
                                onChange={this.handleOnTextChange}
                                value={this.state.pregnancy_risk_factor_management_remarks}
                              />
                            </Form.Item>
                            <label htmlFor="pregnancy_risk_factor_management_remarks">Pregnancy Risk Factor Management Remarks</label>
                          </div>
                        </div>
                      :
                      null
                    }
                  </div>
                :
                null
              }
              {
                show32
                ?
                  <>
                    <div className="row d-flex align-items-center mb-4">
                      <div className='col-auto d-flex align-items-center'>
                        <h6 className='text-primary mb-0 pr-3'>Any Previous Complication</h6>
                        <div className="mr-2 d-md-inline">
                          <Form.Item
                            name="any_previous_complications"
                            className='mb-0'
                          >
                            <Radio.Group name='any_previous_complications' defaultValue={this.state.any_previous_complications} onChange={(e) => this.onChangePreviousComplicationCheck(e)} disabled={!this.state.allowEdit}>
                              <Radio value="0" name="no">No</Radio>
                              <Radio value="1" name="yes">Yes</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    <div className='row align-items-center mb-4' style={{ display: this.state.any_previous_complications === "1" ? 'block' : 'none' }}>
                      <div className='col-12'>
                        <div className='row'>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="aph"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('1')}
                              onChange={e => this.handleComplicationDetailsChange(e, '1')}
                            >
                              APH
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="ec"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('2')}
                              onChange={e => this.handleComplicationDetailsChange(e, '2')}
                            >
                              Eclampsia
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="pih"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('3')}
                              onChange={e => this.handleComplicationDetailsChange(e, '3')}
                            >
                              PIH
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="pph"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('4')}
                              onChange={e => this.handleComplicationDetailsChange(e, '4')}
                            >
                              PPH
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="anemia"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('5')}
                              onChange={e => this.handleComplicationDetailsChange(e, '5')}
                            >
                              Anaemia
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="obslab"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('6')}
                              onChange={e => this.handleComplicationDetailsChange(e, '6')}
                            >
                              Obstructed Labor
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="lscs"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('7')}
                              onChange={e => this.handleComplicationDetailsChange(e, '7')}
                            >
                              LSCS
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="congano"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('8')}
                              onChange={e => this.handleComplicationDetailsChange(e, '8')}
                            >
                              Congenital Anamoly
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="abort"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('9')}
                              onChange={e => this.handleComplicationDetailsChange(e, '9')}
                            >
                              Abortion
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="anyother"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('10')}
                              onChange={e => this.handleComplicationDetailsChange(e, '10')}
                            >
                              Any Other
                            </Checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                :
                null
              }
              {
                show33
                ?
                  <div className='row d-flex align-items-center mb-4'>
                    <div className='col-12'>
                      <div className={this.state.obstetric_remarks ? 'form-group micwrap ant-mic-wrap hasdata mb-0' : 'form-group micwrap ant-mic-wrap mb-0'}>
                        <Link
                          onClick={(e) => {
                              e.preventDefault(); this.initSpeech({ identifier: "obstetric_remarks" });
                          }}
                          className={
                            this.state.speech.identifier === "obstetric_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                          }
                        ></Link>
                        <Input.TextArea
                          className="form-control speech-field"
                          rows="1"
                          placeholder="Obstetric Examination/Remarks"
                          disabled={!this.state.allowEdit}
                          id="obstetric_remarks"
                          oninput="auto_height(this)"
                          onInput={(e) => this.autoHeight(e)}
                          name="obstetric_remarks"
                          onChange={this.handleOnTextChange}
                          value={this.state.obstetric_remarks}
                        />
                        <label htmlFor="obstetric_remarks">Obstetric Examination/Remarks</label>
                      </div>
                    </div>
                  </div>
                :
                null
              }
              {
                (this.state.pregnant == "1" && show26) 
                ?
                  <>
                    <hr className='my-3' />
                    <div className='row d-flex align-items-center mb-4'>
                      <div className='col-auto d-flex align-items-center'>
                        <h6 className='text-primary mb-0 pr-3'>Mother & Fetal Parameters</h6>
                      </div>
                      <div className='col-2'>
                        <div className='antInputItem hasdata'>
                          <Form.Item
                            label="No. of Fetus"
                            name="no_of_fetus"
                            rules={[
                                { required: true, message: 'Please fill No. Of Fetus.' },
                                { pattern: /^[1-9]{1,1}$/, message: 'Not allowed!' },
                                /* {max: 8, message: 'Max 8 chars.'} */
                            ]}
                          >
                            <Input
                              id="no_of_fetus"
                              name="no_of_fetus"
                              disabled={!this.state.allowEdit}
                              onChange={(e) => this.handleFetusChange(e.target.value)}
                              className="onlynumbers"
                              value={this.state.no_of_fetus}
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <div className='col text-right '>
                        <Checkbox
                          name="mother_fetal_print_with_prescription"
                          checked={this.state.mother_fetal_print_with_prescription === '1'}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleMotherFetalPrintWithPrescription(e)}
                        >
                          <span className='text-secondary font-weight-bold'>Print with Prescription</span>
                        </Checkbox>
                      </div>
                    </div>
                    <div className='row d-flex align-items-center mb-4'>
                      <div className='col-12'>
                        <div className='card lightblue-card mb-0'>
                          <div className='row'>
                            <div className='col-7'>
                              <div className='row'>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>POG (Weeks)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_pog"
                                    >
                                      <Input
                                        id="mother_pog"
                                        name="mother_pog"
                                        onChange={this.handleOnTextChange}
                                        disabled={!this.state.allowEdit}
                                        value={this.state.mother_pog}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>Weight (Kg)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_weight"
                                    >
                                      <Input
                                        id="mother_weight"
                                        name="mother_weight"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_weight}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>BP (mmHg)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                        label=""
                                        name="mother_blood_pressure"
                                    >
                                      <Input
                                        id="mother_blood_pressure"
                                        name="mother_blood_pressure"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_blood_pressure}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='col-5'>
                              <div className='row'>
                                <div className='col-6'>
                                  <h6 className='text-primary mb-1'>Pulse Rate (min)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_pulse_rate"
                                    >
                                      <Input
                                        id="mother_pulse_rate"
                                        name="mother_pulse_rate"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_pulse_rate}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-6'>
                                  <h6 className='text-primary mb-1'>Fundal Ht (cm)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                        label=""
                                        name="mother_fundal_height"
                                    >
                                      <Input
                                        id="mother_fundal_height"
                                        name="mother_fundal_height"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_fundal_height}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='row mt-3'>
                            <div className='col-7'>
                              <div className='row'>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>Edema</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_edema"
                                    >
                                      <Input
                                        id="mother_edema"
                                        name="mother_edema"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_edema} 
                                        />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>Pallor</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_pallor"
                                    >
                                      <Input
                                        id="mother_pallor"
                                        name="mother_pallor"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_pallor}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>Cervix Exam</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_cervix_exam"
                                    >
                                      <Input
                                        name="mother_cervix_exam"
                                        id="mother_cervix_exam"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_cervix_exam}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='col-5'>
                              <div className='row'>
                                <div className='col-xl-6 col-8'>
                                  <h6 className='text-primary mb-1'>Preterm Labour (Sign/Symptoms)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_preterm_labour"
                                    >
                                      <Input
                                        id="mother_preterm_labour"
                                        name="mother_preterm_labour"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_preterm_labour}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='row mt-3'>
                            <div className='col-12'>
                              <div className={this.state.mother_remarks ? 'form-group micwrap ant-mic-wrap hasdata mb-0' : 'form-group micwrap ant-mic-wrap mb-0'}>
                                <Link
                                  onClick={(e) => {
                                      e.preventDefault(); this.initSpeech({ identifier: "mother_remarks" });
                                  }}
                                  className={
                                    this.state.speech.identifier === "mother_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                                  }
                                ></Link>
                                <Input.TextArea
                                  className="form-control speech-field"
                                  rows="1"
                                  placeholder="Remarks"
                                  disabled={!this.state.allowEdit}
                                  id="mother_remarks"
                                  oninput="auto_height(this)"
                                  onInput={(e) => this.autoHeight(e)}
                                  name="mother_remarks"
                                  onChange={this.handleOnTextChange}
                                  value={this.state.mother_remarks}
                                />
                                <label htmlFor="mother_remarks">Remarks</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-12'>
                        <div className='card blue-card mb-0'>
                          <Form.List name="blood_bag_master">
                            {() => (
                              mother_fetal_parameters.map((item, key) => (
                                <>
                                  <div className="row mb-4">
                                    <div className="col-1 pt-1">
                                      F{key + 1}
                                    </div>
                                    <div className="col-3">
                                      <div className={'antSelectItem hasdata'}>
                                        <Form.Item
                                          label="Fetal Movement"
                                          preserve={false}
                                        >
                                          <Select
                                            showSearch
                                            style={{ width: '100%' }}
                                            optionFilterProp="children"
                                            value={item.fetal_movement}
                                            disabled={!this.state.allowEdit}
                                            onChange={(val, props) => this.handleFetalParamsSelectChange(val, props, 'fetal_movement', key)}
                                          >
                                            {FETAL_MOVEMENT !== undefined ? Object.keys(FETAL_MOVEMENT).map((d, i) => (
                                                <Option key={i} value={d} label={FETAL_MOVEMENT[d]}>
                                                    {FETAL_MOVEMENT[d]}
                                                </Option>
                                            )) : null}
                                          </Select>
                                          </Form.Item>
                                      </div>
                                    </div>
                                    <div className="col-3">
                                      <div className={'antInputItem hasdata'}>
                                        <Form.Item
                                          label="Fetal Heart Rate (b/min)"
                                          required
                                          preserve={false}
                                          validateStatus={(item.fetal_heart_rate === undefined || item.fetal_heart_rate === null || String(item.fetal_heart_rate).trim() === '') ? 'error' : ''}
                                          help={(item.fetal_heart_rate === undefined || item.fetal_heart_rate === null || String(item.fetal_heart_rate).trim() === '') ? 'Fetal Heart Rate is required' : null}
                                        >
                                          <Input
                                            autoComplete="off"
                                            type="text"
                                            maxLength="3"
                                            name="fetal_heart_rate"
                                            disabled={!this.state.allowEdit}
                                            onChange={(e) => this.handleFetalParamsChange(e, 'fetal_heart_rate', key)}
                                            defaultValue={item.fetal_heart_rate}
                                          />
                                        </Form.Item>
                                      </div>
                                    </div>
                                    <div className="col-3">
                                      <div className={'antSelectItem hasdata'}>
                                        <Form.Item
                                          label="Presentation"
                                          preserve={false}
                                        >
                                          <Select
                                            showSearch
                                            style={{ width: '100%' }}
                                            optionFilterProp="children"
                                            value={item.presentation}
                                            disabled={!this.state.allowEdit}
                                            onChange={(val, props) => this.handleFetalParamsSelectChange(val, props, 'presentation', key)}
                                          >
                                            {PRESENTATION !== undefined ? Object.keys(PRESENTATION).map((d, i) => (
                                                <Option key={i} value={d} label={PRESENTATION[d]}>
                                                    {PRESENTATION[d]}
                                                </Option>
                                            )) : null}
                                          </Select>
                                        </Form.Item>
                                      </div>
                                    </div>
                                    <div className="col-2">
                                      <div className={'antSelectItem hasdata'}>
                                        <Form.Item
                                          label="Relation of PP to Brim"
                                          preserve={false}
                                        >
                                          <Select showSearch style={{ width: '100%' }}
                                            value={item.relationship_of_pp_to_brim}
                                            disabled={!this.state.allowEdit}
                                            onChange={(val, props) => this.handleFetalParamsSelectChange(val, props, 'relationship_of_pp_to_brim', key)}
                                          >
                                            {RELATIONSHIP_TO_PP_BRIM !== undefined ? Object.keys(RELATIONSHIP_TO_PP_BRIM).map((d, i) => (
                                                <Option key={i} value={d} label={RELATIONSHIP_TO_PP_BRIM[d]}>
                                                    {RELATIONSHIP_TO_PP_BRIM[d]}
                                                </Option>
                                            )) : null}
                                          </Select>
                                        </Form.Item>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-4">
                                    <div className="col-1 pt-1">
                                        &nbsp;
                                    </div>
                                    <div className="col-3">
                                        <div className={'antInputItem hasdata'}>
                                          <Form.Item
                                                label="Head CC (cm)"
                                                preserve={false}
                                            >
                                            <Input
                                                type="text"
                                                autoComplete="off"
                                                maxLength="4"
                                                name="head_cc"
                                                disabled={!this.state.allowEdit}
                                                defaultValue={item.head_cc}
                                                onChange={(e) => this.handleFetalParamsChange(e, 'head_cc', key)}
                                            />
                                          </Form.Item>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className={'antInputItem hasdata'}>
                                          <Form.Item
                                              label="Abdominal CC (cm)"
                                              preserve={false}
                                          >
                                            <Input
                                                type="text"
                                                autoComplete="off"
                                                placeholder="Abdominal CC (cm)"
                                                maxLength="4"
                                                name="abdominal_cc"
                                                disabled={!this.state.allowEdit}
                                                defaultValue={item.abdominal_cc}
                                                onChange={(e) => this.handleFetalParamsChange(e, 'abdominal_cc', key)}
                                            />
                                          </Form.Item>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className={'antInputItem hasdata'}>
                                          <Form.Item
                                              label="Femur Length (cm)"
                                              preserve={false}
                                          >
                                            <Input
                                                type="text"
                                                autoComplete="off"
                                                placeholder="Femur Length (cm)"
                                                maxLength="4"
                                                name="femur_length"
                                                disabled={!this.state.allowEdit}
                                                defaultValue={item.femur_length}
                                                onChange={(e) => this.handleFetalParamsChange(e, 'femur_length', key)}

                                            />
                                          </Form.Item>
                                        </div>
                                    </div>
                                  </div>
                                </>
                              ))
                            )}
                          </Form.List>
                        </div>
                      </div>
                    </div>
                  </>
                :
                null
              }
            </Form>
          </div>
        </div>

        <Modal
          id="alert_confirm_message"
          className="alert_confirm_message"
          visible={this.state.prevRecordedObsGynaePopupVisible}
          bodyStyle={{ padding: "25px 10px" }}
          closable={false}
          width="400px"
          footer={[
              <div className="text-center">
                <button
                  className="btn btn-outline-secondary px-5 cancelOrderSet"
                  onClick={(e) => this.copyPrevRecordedObsGynae(e, 'N')}
                >
                  NO
                </button>
                <button
                  className="btn btn-primary px-5 deleteOrderSet ml-1"
                  id='deleteButton'
                  onClick={(e) => this.copyPrevRecordedObsGynae(e, 'Y')}
                >
                  YES
                </button>
              </div>,
            ]}
          >
            <div className="container-fluid emrfrm">
                <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        The patient was marked pregnant during previous visit. Do you want to copy the pregnancy details from visit date {moment(this.state.obsGynaePrevData?.created_at).format("DD MMM, YYYY")}?
                      </div>
                    </div>
                </div>
            </div>
          </Modal>

          <Modal
            id="pregnant_confirm_message"
            className="alert_confirm_message"
            visible={this.state.pregnantConfirmVisible}
            bodyStyle={{ padding: "25px 10px" }}
            closable={false}
            width="400px"
            footer={[
              <div className="text-center">
                <button
                  className="btn btn-outline-secondary px-5 cancelOrderSet"
                  onClick={this.cancelPregnant}
                >
                  NO
                </button>
                <button
                  className="btn btn-primary px-5 ml-1"
                  onClick={this.confirmPregnant}
                >
                  YES
                </button>
              </div>,
            ]}
          >
            <div className="container-fluid emrfrm">
                <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        Are you sure you want to mark this patient as pregnant?
                      </div>
                    </div>
                </div>
            </div>
          </Modal>

          <Modal
            id="pregnant_audit_details"
            className="pregnant_audit_details"
            title="Pregnancy Audit"
            visible={this.state.pregnantAuditModalVisible}
            bodyStyle={{ padding: "25px 10px" }}
            closable={false}
            width="700px"
            footer={[
              <div className="text-center">
                <button
                  className="btn btn-outline-secondary px-5 cancelOrderSet"
                  onClick={() => this.setState({ pregnantAuditModalVisible: false })}
                >
                  CLOSE
                </button>
              </div>
            ]}
          >
            <div className="container-fluid emrfrm">
                <div className="row">
                    <div className="col-12">
                      <div className="table-responsive">
                        <table className="table table-bordered" id="pregnant-audit-table">
                          <thead>
                            <tr>
                              <th className="text-center">#</th>
                              <th className="text-center">Date</th>
                              <th className="text-center">Marked By</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.pregnantAuditData && this.state.pregnantAuditData.length > 0
                              ? this.state.pregnantAuditData.map((audit, i) => (
                                <tr key={i}>
                                  <td className="text-center">{i + 1}</td>
                                  <td className="text-center">{audit.audit_date ? moment.utc(audit.audit_date).format('DD MMM, YYYY hh:mm A') : '-'}</td>
                                  <td className="text-center">{audit.doctor_name || '-'}</td>
                                </tr>
                              ))
                              : (
                                <tr>
                                  <td className="text-center" colSpan="3">No audit records found</td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                </div>
            </div>
          </Modal>

          {/* Edit LMP popup: new LMP date + mandatory reason (audited). */}
          <Modal
            id="lmp_edit_modal"
            className="lmp_edit_modal"
            title="Edit LMP"
            visible={this.state.lmpEditModalVisible}
            bodyStyle={{ padding: "20px" }}
            closable={false}
            width="450px"
            footer={[
              <div className="text-center" key="lmp-edit-footer">
                <button
                  className="btn btn-outline-secondary px-4 mr-2"
                  onClick={this.cancelLmpEdit}
                  disabled={this.state.lmpEditSaving}
                >
                  CANCEL
                </button>
                <button
                  className="btn btn-primary px-4"
                  onClick={this.confirmLmpEdit}
                  disabled={this.state.lmpEditSaving}
                >
                  {this.state.lmpEditSaving ? 'SAVING...' : 'CONFIRM'}
                </button>
              </div>,
            ]}
          >
            <div className="container-fluid emrfrm">
              <div className="row">
                <div className="col-12 mb-2">
                  <span className="text-muted">Current LMP: </span>
                  <b>{this.state.lmp ? moment(this.state.lmp).format('DD MMM, YYYY') : '-'}</b>
                </div>
              </div>
              <div className="row">
                <div className="col-12 mb-3">
                  <label className="mb-1">New LMP <span className="text-danger">*</span></label>
                  <DatePicker
                    format="DD MMM, YYYY"
                    style={{ width: "100%", height: "34px" }}
                    allowClear={false}
                    value={this.state.lmpEditNewDate}
                    onChange={(date) => this.handleLmpEditDateChange(date)}
                    disabledDate={this.disabledLmpDate}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <label className="mb-1">Reason <span className="text-danger">*</span></label>
                  <Input.TextArea
                    rows={3}
                    maxLength={500}
                    placeholder="Enter reason for changing the LMP"
                    value={this.state.lmpEditReason}
                    onChange={this.handleLmpEditReasonChange}
                  />
                </div>
              </div>
            </div>
          </Modal>

          {/* LMP change audit log */}
          <Modal
            id="lmp_audit_details"
            className="lmp_audit_details"
            title="LMP Change Log"
            visible={this.state.lmpAuditModalVisible}
            bodyStyle={{ padding: "25px 10px" }}
            closable={false}
            width="750px"
            footer={[
              <div className="text-center" key="lmp-audit-footer">
                <button
                  className="btn btn-outline-secondary px-5"
                  onClick={() => this.setState({ lmpAuditModalVisible: false })}
                >
                  CLOSE
                </button>
              </div>
            ]}
          >
            <div className="container-fluid emrfrm">
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table table-bordered" id="lmp-audit-table">
                      <thead>
                        <tr>
                          <th className="text-center">#</th>
                          <th className="text-center">Previous LMP</th>
                          <th className="text-center">New LMP</th>
                          <th className="text-center">Reason</th>
                          <th className="text-center">Changed By</th>
                          <th className="text-center">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.lmpAuditData && this.state.lmpAuditData.length > 0
                          ? this.state.lmpAuditData.map((audit, i) => (
                            <tr key={i}>
                              <td className="text-center">{i + 1}</td>
                              <td className="text-center">{audit.previous_lmp ? moment(audit.previous_lmp).format('DD MMM, YYYY') : '-'}</td>
                              <td className="text-center">{audit.new_lmp ? moment(audit.new_lmp).format('DD MMM, YYYY') : '-'}</td>
                              <td>{audit.reason || '-'}</td>
                              <td className="text-center">{audit.changed_by_name || '-'}</td>
                              <td className="text-center">{audit.audit_date ? moment.utc(audit.audit_date).format('DD MMM, YYYY hh:mm A') : '-'}</td>
                            </tr>
                          ))
                          : (
                            <tr>
                              <td className="text-center" colSpan="6">No LMP change records found</td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          {this.state.previousPregnancyDetailsModal && (
            <PreviousPregnancyModal
              visible={this.state.previousPregnancyDetailsModal}
              onClose={(e) => this.closePopup(e, 'obsHistoryList')}
              patientId={parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid)}
              hospitalId={parseInt(LS_SERVICE.get('FACILITY_ID'))}
              enterpriseId={parseInt(LS_SERVICE.get('ENTERPRISE_ID'))}
              referenceId={parseInt(LS_SERVICE.get('call_patient_qms_token_id'))}
              referenceType={0}
              source={'OP'}
              patientAge={this.state.patient_dob}
            />
          )}
      </Fragment> 
		);
	}
}

export default ObsGynaeComponentSS;